var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404ErrorwithpeopleholdingthenumbersPana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.51,321.73a1.35,1.35,0,0,1,0-.24c0-.17,0-.39,0-.66,0-.6,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.44l.15.15-48.65.09.24-.24h0v12.85l-.25-.25,34.68.11,10.23.07,2.77,0h.72l.26,0h-.23l-.69,0-2.72,0-10.18.07-34.84.11h-.24V308.88h0l.25-.25,48.65.1h.15v.15c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A1.66,1.66,0,0,1,694.51,321.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.1,308.86s0-.09,0-.25,0-.41,0-.68c0-.63,0-1.5-.05-2.58,0-2.26,0-5.45-.1-9.36l.18.17-29.23.07c-.22.22.3-.3.25-.24h0v6.61c0,2.15,0,4.24,0,6.24l-.24-.24,20.91.11,6.09.07,1.65,0,.58,0a3.28,3.28,0,0,1-.53,0l-1.59,0-6,.07-21.07.11h-.23v-6.47c0-1.08,0-2.17,0-3.28V296h0l.25-.25,29.23.07h.18V296c0,4-.07,7.18-.09,9.47,0,1.07,0,1.91-.05,2.54A5,5,0,0,1,701.1,308.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.51,321.73a1.35,1.35,0,0,1,0-.24c0-.17,0-.39,0-.66,0-.6,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.44l.15.15-48.65.09.24-.24h0v12.85l-.25-.25,34.68.11,10.23.07,2.77,0h.72l.26,0h-.23l-.69,0-2.72,0-10.18.07-34.84.11h-.24V308.88h0l.25-.25,48.65.1h.15v.15c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A1.66,1.66,0,0,1,694.51,321.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.1,308.86s0-.09,0-.25,0-.41,0-.68c0-.63,0-1.5-.05-2.58,0-2.26,0-5.45-.1-9.36l.18.17-29.23.07c-.22.22.3-.3.25-.24h0v6.61c0,2.15,0,4.24,0,6.24l-.24-.24,20.91.11,6.09.07,1.65,0,.58,0a3.28,3.28,0,0,1-.53,0l-1.59,0-6,.07-21.07.11h-.23v-6.47c0-1.08,0-2.17,0-3.28V296h0l.25-.25,29.23.07h.18V296c0,4-.07,7.18-.09,9.47,0,1.07,0,1.91-.05,2.54A5,5,0,0,1,701.1,308.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.63,
    y: 98.97,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.71,125.4a1.35,1.35,0,0,1,0-.24v-.66c0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.08-9.44l.15.15-48.65.09.24-.24h0V125.4l-.24-.24,34.67.11,10.23.06,2.77,0h.72l.26,0h-.23l-.69,0-2.72,0-10.17.07-34.84.11h-.25V112.55h0c.49-.5.14-.14.25-.25l48.65.1h.15v.15c0,4.06-.07,7.29-.08,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A1.66,1.66,0,0,1,117.71,125.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.12,
    y: 343.63,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.2,370.06a1.35,1.35,0,0,1,0-.24v-.66c0-.6,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.44l.15.15-48.65.09.24-.24h0v12.85l-.25-.25,34.68.11,10.23.07,2.77,0h.72l.26,0H473l-.69,0-2.72,0-10.17.07-34.85.11h-.24V357.21h0l.25-.25,48.65.09h.15v.15c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A1.66,1.66,0,0,1,473.2,370.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.38,
    y: 119.21,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.53,
    y: 183.07,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.19,60.36a1.17,1.17,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.54,0-2.22-.05-5.41-.08-9.44l.15.15-48.65.1c.11-.11-.25.24.24-.25h0V60.36l-.25-.24,34.68.11,10.23.07,2.77,0h.72l.26,0-.23,0h-.69l-2.72,0-10.18.07-34.84.11h-.24V47.51h0l.25-.25,48.65.1h.15v.15c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5l0,.64A1.23,1.23,0,0,1,228.19,60.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.78,47.49s0-.09,0-.25,0-.4,0-.68c0-.63,0-1.49-.05-2.58,0-2.26,0-5.44-.09-9.36l.17.18-29.23.07c-.22.22.3-.31.25-.25h0v6.61c0,2.15,0,4.24,0,6.24l-.24-.24,20.91.12,6.09.06,1.65,0,.58,0a3.28,3.28,0,0,1-.53,0l-1.59,0-6,.06-21.07.12h-.23v-.24c0-2,0-4.09,0-6.24,0-1.08,0-2.17,0-3.28V34.64h0l.25-.25,29.23.07H235v.18c0,4-.07,7.19-.09,9.47,0,1.07,0,1.92-.05,2.54A4.88,4.88,0,0,1,234.78,47.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.89,67.05a1.3,1.3,0,0,1,0-.23v-.67c0-.6,0-1.45,0-2.53,0-2.22-.05-5.41-.08-9.44l.15.15-48.65.1c.11-.11-.25.24.24-.25h0V67.05l-.24-.24,34.67.11,10.23.07,2.77,0h.72l.26,0h-.23l-.69,0-2.71,0-10.18.07-34.84.11H576V54.2h0l.25-.25,48.65.1H625v.15c0,4.06-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5l0,.63A1.66,1.66,0,0,1,624.89,67.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.49,54.18a.77.77,0,0,1,0-.25c0-.18,0-.41,0-.68,0-.63,0-1.49-.05-2.58,0-2.26,0-5.44-.09-9.36l.18.18-29.23.06.24-.24h0v6.61c0,2.15,0,4.24,0,6.24l-.24-.24,20.92.11,6.09.07,1.64,0,.59,0a3.43,3.43,0,0,1-.53,0l-1.6,0-6,.06-21.07.11H602v-.23c0-2,0-4.09,0-6.24V41.33h0l.25-.25,29.23.07h.18v.18c0,4-.07,7.19-.09,9.47,0,1.07,0,1.92-.05,2.54S631.5,54.19,631.49,54.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.62,134.67a2.07,2.07,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.54,0-2.22,0-5.41-.08-9.44l.15.15-48.65.1.25-.25h0v3.27c0,1.09,0,2.18,0,3.25v6.33l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26s-.07,0-.22,0h-.7l-2.71,0-10.18.06-34.84.11h-.24v-.25q0-3.1,0-6.33v-6.52h0c.5-.49.14-.14.25-.25l48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.91,0,2.5v.64C334.63,134.61,334.63,134.68,334.62,134.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.22,121.8a1.35,1.35,0,0,1,0-.24c0-.19,0-.41,0-.69,0-.63,0-1.49,0-2.58,0-2.25-.06-5.44-.1-9.36l.18.18-29.23.07c-.23.22.3-.3.24-.25h0v6.61c0,2.15,0,4.24,0,6.24l-.23-.23,20.91.11,6.09.06,1.64,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.6,0-6,.07L312,122h-.24v-.24c0-2,0-4.09,0-6.24V109h0c-.06,0,.47-.47.25-.25l29.23.07h.18v.18c0,4-.08,7.19-.1,9.47,0,1.07,0,1.92,0,2.54S341.23,121.81,341.22,121.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.51,294.63a1.35,1.35,0,0,1,0-.24c0-.17,0-.39,0-.66,0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.08-9.44l.15.15L35.86,282l.24-.24h0v12.87l-.25-.25,34.68.11,10.23.07,2.77,0,.72,0,.26,0h-.23l-.69,0-2.72,0-10.18.07-34.84.11h-.24V281.76h0l.25-.25,48.65.09h.15v.16c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5l0,.63A1.66,1.66,0,0,1,84.51,294.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,281.76s0-.09,0-.25,0-.41,0-.68c0-.64,0-1.5,0-2.58,0-2.26-.06-5.45-.1-9.37l.18.18-29.23.07c-.22.22.3-.3.25-.24h0v6.6q0,3.24,0,6.24l-.24-.23,20.91.11,6.09.07,1.65,0,.58,0-.53,0-1.59,0-6,.07L61.87,282h-.23v-6.48c0-1.07,0-2.17,0-3.27v-3.33h0l.25-.25,29.23.07h.18v.17c0,4-.07,7.19-.09,9.48,0,1.07,0,1.91,0,2.54A5,5,0,0,1,91.1,281.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,358.68a30.69,30.69,0,0,0-13.13-4.52c-2.15-.22-4.49-.16-6.21,1.14a1.27,1.27,0,0,0-.64,1.13,1.35,1.35,0,0,0,.61.78,18.76,18.76,0,0,0,19.37,1.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,358.31a64.78,64.78,0,0,1-8.48-7.46,21.53,21.53,0,0,1-5.32-9.84,4,4,0,0,1,.42-3.29c6.76,5.28,12.07,12.11,13.38,20.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.23,358.63a30.66,30.66,0,0,1,.15-11.14,15.06,15.06,0,0,1,5.93-9.18c1.17,2.73.67,5.87-.15,8.72a42.62,42.62,0,0,1-5.88,12.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.85,370.5a19.44,19.44,0,0,0-10.53,5.33,20,20,0,0,0-6,10.34c3.95-.25,7.29-3,9.72-6.15s4.11-6.54,6.78-9.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.29,372.4a26,26,0,0,1,3-24.57c2.29,8.16,1.45,17.36-3,24.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.05,382.82a18.8,18.8,0,0,0-18,10.34c-.22.44-.42,1-.12,1.41a1.38,1.38,0,0,0,1.19.35c3.54-.23,6.68-2.36,9.26-4.79s4.85-5.22,7.71-7.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77,382.26a33.44,33.44,0,0,1-.34-18.68c.66-2.41,1.77-4.94,4-6.07a.78.78,0,0,1,.61-.1.81.81,0,0,1,.39.44,11.28,11.28,0,0,1,.94,5.36,35.83,35.83,0,0,1-.84,5.43c-.7,3.31-1.08,6.88-2.9,9.74a19,19,0,0,0-1.15,2.13c-.35.73-.35,1-.66,1.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.94,385.71a24.12,24.12,0,0,1,4.22-19.8c.31-.4.71-.82,1.2-.78.76.07,1,1.08.92,1.85a35.69,35.69,0,0,1-6.34,18.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,387.14a28.85,28.85,0,0,0,23.64-4.81,19.14,19.14,0,0,0-12.8-1.57c-4.27,1-8.18,2.89-10.84,6.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.79,382.79c4.45-7.25,13-12,21.46-12.41-1,3.46-3.82,6.14-7,7.76a38.88,38.88,0,0,1-10.3,3c-1.37.27-3.25.56-4.14,1.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.38,361.69a61.91,61.91,0,0,0,2.75-12.57,20.91,20.91,0,0,0-2.5-12.42c-4.16,8-4.58,17.41-.37,25.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.36,354.62c4.85-8.82,14.76-15.87,24.78-16.85-3.87,9.62-14.41,17.06-24.78,16.85",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.31,356.35c7.24,1.1,13.4,5.73,20.17,8.53a9.09,9.09,0,0,0,4.56.88,3.57,3.57,0,0,0,2.23-6.32,9.75,9.75,0,0,0-3.31-2c-7.37-3.07-15.27-3.14-23-1.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.12,361.43c1.64.47,2.2,1.32,3.49,2.42a37.75,37.75,0,0,0,15.3,7.86c.59.15,1.35.2,1.64-.32s-.07-1-.39-1.43a21,21,0,0,0-9.24-6.27c-3.53-1.32-6.59-2.9-10.8-2.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.39,330.76a28.91,28.91,0,0,0,22.19,7.55,1.47,1.47,0,0,0,1-.36c.56-.61-.11-1.55-.76-2.05-6.52-5.09-14.43-7.2-22.44-5.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,328.71a31,31,0,0,1,27.7-4.57,21.94,21.94,0,0,1-13.2,5.79,41.74,41.74,0,0,1-14.5-1.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.77,314.62c-.65-6.52-.23-11.66-.68-18.2,0-.52-.15-1.15-.64-1.34-.68-.26-1.25.57-1.47,1.27a20.83,20.83,0,0,0,2.78,18.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.3,315.34a38.48,38.48,0,0,0,10.79-10.49c2.13-2.91,3.92-6.41,3.44-10a10.3,10.3,0,0,0-7.78,3.87,21.53,21.53,0,0,0-4,8c-.86,2.87-1.47,5.81-2.48,8.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.9,312.39a86.91,86.91,0,0,0,26.55-15.65c-3.17-1.28-6.8-.52-10,.76a31.44,31.44,0,0,0-16.72,14.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.28,318.9A53.52,53.52,0,0,0,314,319c4.78-.8,9.3-2.69,13.77-4.57a1.6,1.6,0,0,0,.93-.71,1.07,1.07,0,0,0-.33-1.18,3,3,0,0,0-1.18-.55c-4.85-1.36-10.09-.72-14.87.89a69.09,69.09,0,0,0-13.06,6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,331c-3.35-6.75-3.13-14.62-.24-21.58,2,3.1,2.28,7,1.91,10.73s-1.49,7.48-1.57,11.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,324.25a30.07,30.07,0,0,0-22.37,9.53,20.94,20.94,0,0,0,12.25-2.27,62.88,62.88,0,0,0,10.5-7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,321.24c-4.09-.33-8-.83-11.94.37a14.3,14.3,0,0,0-9.11,7.72,21.57,21.57,0,0,0,11.2-2.12,64,64,0,0,0,9.85-6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,321.38c-3.68-2.41-7.45-4.86-11.73-5.86s-9.24-.26-12.22,3c3.46,2,7.66,2.27,11.68,2.27s8.94-.05,12.73,1.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.27,321.57c-6.28-6.16-8.67-17.25-6.14-25.68a39.14,39.14,0,0,1,6.14,25.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,304.1c1.19-2.76,2-5.65,3.08-8.45a24.27,24.27,0,0,1,4.4-7.79,11.48,11.48,0,0,1,7.78-4,31.39,31.39,0,0,1-15.1,20.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.42,307.74c-2-2.7-4.23-6.36-6.89-8.38s-6.12-3.23-9.36-2.46a21.81,21.81,0,0,0,16.25,10.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,304.32a47,47,0,0,1-3.1-10,15.67,15.67,0,0,1,1.57-10.2c3.45,6.52,4.56,13.51,1.71,20.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57,284.08c2-6.46,7.87-11.22,14.26-13.4a5.28,5.28,0,0,1,2.5-.38,2.17,2.17,0,0,1,1.84,1.54c.24,1.1-.67,2.08-1.52,2.81a48.47,48.47,0,0,1-17.08,9.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.64,278.79c.25-4.16.51-8.39,1.87-12.34s4-7.65,7.76-9.37c.65,4.2-1.21,8.39-3.45,12s-4.93,7-6.28,11.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,281.66c-1.61-4.71-1.78-10.69-4.6-14.79-2-2.87-5.13-4.82-6.83-7.86a12,12,0,0,0,.4,8.92,25.74,25.74,0,0,0,5.22,7.47c2.09,2.23,3.87,3.91,5.81,6.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57,420.35c-.12,0-.23-31.42-.24-70.16s.09-70.17.21-70.17.24,31.41.24,70.17S279.7,420.35,279.57,420.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,326.24a6.5,6.5,0,0,1-1.18.45l-3.25,1.09c-2.75.94-6.51,2.29-10.6,4s-7.86,3.15-10,5a7.4,7.4,0,0,0-2,2.67c-.31.74-.37,1.19-.41,1.18a1,1,0,0,1,0-.33,4.43,4.43,0,0,1,.23-.91,7.1,7.1,0,0,1,2-2.85,17.91,17.91,0,0,1,4.36-2.7c1.74-.82,3.67-1.66,5.72-2.51,4.1-1.68,7.89-3,10.67-3.84,1.38-.43,2.51-.75,3.3-1A6.5,6.5,0,0,1,307,326.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,304.14a2.54,2.54,0,0,1-.33.35l-1,.95-3.77,3.42L298.4,320c-4.89,4.35-9.12,8.51-12,11.64-1.46,1.57-2.62,2.86-3.4,3.77l-.91,1a2.74,2.74,0,0,1-.34.34s.08-.15.26-.4.47-.63.85-1.1c.75-.94,1.87-2.27,3.31-3.86a156.46,156.46,0,0,1,12-11.77c4.9-4.34,9.37-8.24,12.61-11.05l3.86-3.31,1.06-.89A2.35,2.35,0,0,1,316,304.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.12,324.44c-.13-.06.89-2.42,1.91-5.4s1.51-5.5,1.64-5.48a18.34,18.34,0,0,1-1.21,5.62,37.1,37.1,0,0,1-1.52,3.78A6.57,6.57,0,0,1,293.12,324.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.6,343.45a5.77,5.77,0,0,1-.75-.87l-1.93-2.48c-1.62-2.09-3.86-5-6.38-8.15s-4.82-6-6.49-8.06c-.79-1-1.45-1.8-2-2.44a6.31,6.31,0,0,1-.68-.94,5.5,5.5,0,0,1,.82.82c.5.55,1.21,1.35,2.08,2.35,1.74,2,4.09,4.82,6.61,8s4.72,6.09,6.28,8.24c.77,1.07,1.39,1.95,1.81,2.56A5.24,5.24,0,0,1,279.6,343.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.58,335.72a11.05,11.05,0,0,1-2.52-4.72,13.39,13.39,0,0,1-.57-4.76l.2,0c-.09.36-.16.56-.19.55s0-.21,0-.58h.2a21.1,21.1,0,0,0,.81,4.63A34.34,34.34,0,0,0,273.58,335.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.81,326a7.74,7.74,0,0,0-1.76-1,11.65,11.65,0,0,0-4.89-.39,30.52,30.52,0,0,0-4.92.79,15.26,15.26,0,0,1-2,.49,6.81,6.81,0,0,1,1.94-.8,22.78,22.78,0,0,1,5-.94,10.8,10.8,0,0,1,5,.55A3.11,3.11,0,0,1,265.81,326Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,323.58c0,.07-1-.41-2.7-1a27.51,27.51,0,0,0-6.73-1.39,28,28,0,0,0-6.86.35c-1.74.31-2.79.64-2.82.56a2.84,2.84,0,0,1,.72-.3,14.78,14.78,0,0,1,2-.57,24.24,24.24,0,0,1,7-.49,23.88,23.88,0,0,1,6.8,1.54,16.8,16.8,0,0,1,1.93.87A2.65,2.65,0,0,1,264,323.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,313.56a57.14,57.14,0,0,1-2-6.83,56.58,56.58,0,0,1-1.52-7,56,56,0,0,1,2,6.84A55.29,55.29,0,0,1,279.54,313.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.67,313.56a34,34,0,0,0-2.18-4.09,18,18,0,0,0-3.21-3.31,3,3,0,0,1,1.24.64,10,10,0,0,1,2.34,2.41A9.14,9.14,0,0,1,279.67,313.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57,403.6c-.05,0-.14-.75-.49-2.09a30.11,30.11,0,0,0-2.1-5.44,75.28,75.28,0,0,0-11.14-15.69c-2.49-2.84-4.9-5.52-6.95-8.09a56.48,56.48,0,0,1-5-7.16,34,34,0,0,1-2.51-5.32c-.23-.65-.4-1.16-.5-1.52a2.46,2.46,0,0,1-.12-.54s.26.72.78,2A39.24,39.24,0,0,0,254.2,365a60.16,60.16,0,0,0,5,7.06c2,2.54,4.47,5.21,7,8.05a71.9,71.9,0,0,1,11.09,15.85,27.27,27.27,0,0,1,2,5.54,15.48,15.48,0,0,1,.28,1.58A2.28,2.28,0,0,1,279.57,403.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38,375.58a10.4,10.4,0,0,1-1.3.73,28.37,28.37,0,0,0-3.37,2.23,38.71,38.71,0,0,0-4.43,4c-1.55,1.64-3.16,3.55-4.79,5.59-3.27,4.1-6.32,7.73-8.15,10.63-.93,1.43-1.61,2.64-2,3.49a9.59,9.59,0,0,1-.72,1.31,1.8,1.8,0,0,1,.12-.37c.1-.23.23-.58.44-1a31.52,31.52,0,0,1,1.94-3.59,113.23,113.23,0,0,1,8.07-10.74c1.63-2.05,3.25-4,4.84-5.6a35.3,35.3,0,0,1,4.54-4,24.43,24.43,0,0,1,3.48-2.13c.43-.21.78-.34,1-.44A1.59,1.59,0,0,1,304.38,375.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.87,384.67a17.54,17.54,0,0,1-2.75.4,36.58,36.58,0,0,0-6.52,1.28,19.76,19.76,0,0,0-5.83,3.07c-1.35,1-2,1.9-2,1.85a2.15,2.15,0,0,1,.41-.64,11,11,0,0,1,1.43-1.46,17.84,17.84,0,0,1,5.9-3.25,29.56,29.56,0,0,1,6.63-1.17A15.56,15.56,0,0,1,304.87,384.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.53,390.27c-.15-.08,1.09-2,2.05-4.52s1.11-4.82,1.28-4.79a4.79,4.79,0,0,1-.05,1.47,15.83,15.83,0,0,1-.8,3.48,16.66,16.66,0,0,1-1.6,3.18A4.31,4.31,0,0,1,288.53,390.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.42,351.18a3.31,3.31,0,0,1-.44.23l-1.29.59c-.57.24-1.26.55-2,1s-1.68.81-2.63,1.38l-1.5.85c-.52.3-1,.65-1.58,1-1.1.67-2.21,1.5-3.39,2.34a57.77,57.77,0,0,0-13.07,13.53c-.81,1.21-1.59,2.35-2.23,3.47-.32.56-.66,1.09-.94,1.62s-.54,1-.8,1.52c-.53,1-.91,1.89-1.29,2.68s-.66,1.48-.89,2.05-.39,1-.54,1.31a1.72,1.72,0,0,1-.22.45,2.22,2.22,0,0,1,.14-.48c.12-.35.27-.8.46-1.34s.46-1.29.82-2.1.72-1.73,1.24-2.71L283,377c.28-.54.61-1.07.93-1.64.62-1.14,1.4-2.29,2.2-3.52a56.3,56.3,0,0,1,13.17-13.62c1.2-.84,2.32-1.66,3.44-2.32.56-.34,1.08-.69,1.61-1l1.52-.84c1-.55,1.88-.94,2.67-1.32a20.39,20.39,0,0,1,2.07-.89l1.32-.51A1.47,1.47,0,0,1,312.42,351.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.78,364.33a3.2,3.2,0,0,1,1.08-1.61,6.81,6.81,0,0,1,4.35-1.66,12,12,0,0,1,4.58.89,6.44,6.44,0,0,1,1.73.84,11.28,11.28,0,0,1-1.84-.54,13.77,13.77,0,0,0-4.45-.74,7,7,0,0,0-4.16,1.46A12.91,12.91,0,0,0,292.78,364.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,367.36a11.69,11.69,0,0,0,1-8.21,2.71,2.71,0,0,1,.51,1.17,8.29,8.29,0,0,1,.21,3.07,8.08,8.08,0,0,1-.92,2.95C290.23,367,289.89,367.39,289.85,367.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.88,408.1c.67,12,4.29,24.22,9.86,36.57h24.19c5.31-12.23,8.68-24.42,9.28-36.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.29,427.53c0,.13-8,.23-17.8.23s-17.79-.1-17.79-.23,8-.23,17.79-.23S297.29,427.41,297.29,427.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,431.88c0,.13-7.47.23-16.69.23s-16.68-.1-16.68-.23,7.47-.23,16.68-.23S296.75,431.76,296.75,431.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13,416a70.62,70.62,0,0,1,0,11.14,67.56,67.56,0,0,1,0-11.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.09,416a72.49,72.49,0,0,1,0,11.54,72.49,72.49,0,0,1,0-11.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,415.89a75.4,75.4,0,0,1,0,11.77,78.82,78.82,0,0,1,0-11.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.44,416c0,.12-9.35.22-20.87.22s-20.87-.1-20.87-.22,9.34-.23,20.87-.23S300.44,415.86,300.44,416Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.55,444.41c0,.14-147.56.26-329.53.26s-329.57-.12-329.57-.26S192,444.15,374,444.15,703.55,444.27,703.55,444.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.78,284c-8.36,4.33-14.78,11.79-19.39,20s-7.59,17.23-10.53,26.18l-2.58,46.16c9.74-16.57,17.55-36,19.66-55.13l-6.48-.57c4.34-.67,8-3.81,10.31-7.54s3.51-8,4.68-12.27l-7.9,1.17A29.3,29.3,0,0,0,692.78,284Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M692.78,284c-8.36,4.33-14.78,11.79-19.39,20s-7.59,17.23-10.53,26.18l-2.58,46.16c9.74-16.57,17.55-36,19.66-55.13l-6.48-.57c4.34-.67,8-3.81,10.31-7.54s3.51-8,4.68-12.27l-7.9,1.17A29.3,29.3,0,0,0,692.78,284Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M658.84,387.15S637.71,361.86,638,337.72h8.53s-9.27-6.1-8.54-9.51,1-16.34,1-16.34l7.8,1.95s-5.85-2.93-6.58-7.56,1.71-26.09,1.71-26.09,9.51,10,12.43,20.24,10.61,22.19,8.36,53.4S658.84,387.15,658.84,387.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.55,389.54s22.89-15.25,28-34.71L690.67,353s8.78-2.87,8.94-5.78,2.79-13.35,2.79-13.35l-6.7-.14s5.34-1.07,6.95-4.64S707,307.7,707,307.7s-9.83,6-14.42,13.55-13.39,15.52-18.4,41.11S669.55,389.54,669.55,389.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.63,302.22a.77.77,0,0,1,.08.26l.19.78c.17.72.39,1.72.68,3,.59,2.61,1.37,6.39,2.27,11.09s1.87,10.29,2.85,16.53,1.91,13.12,2.76,20.35,1.47,14.16,2,20.46.81,12,1,16.74.31,8.64.33,11.31c0,1.3,0,2.33,0,3.07v.8a1.58,1.58,0,0,1,0,.28,1.33,1.33,0,0,1,0-.28c0-.2,0-.47,0-.79,0-.75-.07-1.77-.12-3.08-.08-2.66-.24-6.52-.48-11.29s-.62-10.43-1.11-16.73-1.17-13.19-2-20.43-1.78-14.1-2.71-20.34-1.88-11.84-2.74-16.54-1.58-8.49-2.11-11.1c-.24-1.28-.44-2.29-.58-3-.06-.32-.1-.58-.14-.79A.93.93,0,0,1,647.63,302.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.91,402.64s-19.34-21.94-25.34-35.2l4.53-1.94c-3.28.54-6.65-.87-9.2-3a35.31,35.31,0,0,1-6.25-7.75l6-1a22.18,22.18,0,0,1-13-10.1c7,1.16,13.42,5,18.67,9.86a93.07,93.07,0,0,1,11.31,13.11,44.44,44.44,0,0,1,4.4,7.23C650.21,380.55,655.92,394.58,655.91,402.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.83,320.47s0,.08-.08.23-.18.38-.29.64l-1.17,2.44c-1,2.11-2.49,5.17-4.26,9-3.55,7.6-8.23,18.22-12.85,30.16s-8.3,22.95-10.79,31c-1.25,4-2.23,7.26-2.88,9.51l-.78,2.59-.22.67a.92.92,0,0,1-.09.23,1,1,0,0,1,0-.24c0-.19.1-.41.17-.68.17-.64.39-1.52.68-2.62.6-2.27,1.53-5.54,2.73-9.57,2.4-8,6-19.08,10.65-31s9.37-22.56,13-30.13c1.82-3.79,3.33-6.83,4.42-8.91.53-1,.95-1.81,1.25-2.4l.34-.62A1.23,1.23,0,0,1,697.83,320.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.55,412a9.71,9.71,0,0,1-.31-1.57c-.15-1-.41-2.47-.77-4.26a86.48,86.48,0,0,0-10-26.59c-.91-1.58-1.68-2.85-2.24-3.71a9.15,9.15,0,0,1-.8-1.38,9.48,9.48,0,0,1,1,1.27c.61.83,1.43,2.07,2.39,3.63A78.52,78.52,0,0,1,653,392.32a77.48,77.48,0,0,1,3.8,13.82c.32,1.81.52,3.28.61,4.31A8.19,8.19,0,0,1,657.55,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.74,
    y: 406.88,
    width: 42.32,
    height: 8.63,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.78 415.51 649.36 444.55 674.93 444.55 679.19 415.51 644.78 415.51",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.47,415.51c0,.14-8,.26-17.88.26s-17.88-.12-17.88-.26,8-.26,17.88-.26S680.47,415.37,680.47,415.51Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1,418.67s-3.78-26-3.46-41.06,0-32.1,0-32.1h1.74s-1.18,30,.1,48.06,4.66,25.1,4.66,25.1h-3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.35,316.3A4.59,4.59,0,0,0,97.76,314,4.39,4.39,0,0,0,94,314c-5.26,1.86-9.92,11.66-12,16.82l7,23.51C101.51,342.66,103.69,327.32,99.35,316.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.35,314.93a1,1,0,0,1-.1.31l-.34.86c-.31.74-.73,1.81-1.25,3.15-1,2.67-2.34,6.4-3.51,10.61s-2,8.08-2.46,10.9c-.25,1.41-.44,2.55-.55,3.35-.07.37-.11.67-.15.91a1.77,1.77,0,0,1-.07.31,1.11,1.11,0,0,1,0-.32c0-.24.06-.55.09-.92.09-.8.25-1.95.47-3.36a100.35,100.35,0,0,1,6-21.55c.54-1.33,1-2.4,1.34-3.13l.39-.83A1.71,1.71,0,0,1,97.35,314.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.81,360A21.28,21.28,0,0,1,75.06,342.1c-.26-5.22,1.35-10.34,3.16-15.24a2,2,0,0,1,.74-1.1,1.89,1.89,0,0,1,1.79.27c4.75,2.71,7.63,7.87,9.16,13.12A26.52,26.52,0,0,1,91,349.94a17.91,17.91,0,0,1-5.18,10",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.81,360a1.09,1.09,0,0,1,0-.31c0-.24,0-.54,0-.91,0-.78,0-1.91-.1-3.31a89.59,89.59,0,0,0-1.21-10.86c-.73-4.22-1.61-8-2.26-10.72l-.77-3.22-.2-.88a1,1,0,0,1,0-.32,1.61,1.61,0,0,1,.1.3c.07.23.15.52.26.87.21.75.51,1.85.86,3.21.7,2.71,1.61,6.48,2.34,10.71a79.39,79.39,0,0,1,1.14,10.9c0,1.4,0,2.54,0,3.33q0,.54,0,.9A1.61,1.61,0,0,1,85.81,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.81,360A21.28,21.28,0,0,1,75.06,342.1c-.26-5.22,1.35-10.34,3.16-15.24a2,2,0,0,1,.74-1.1,1.89,1.89,0,0,1,1.79.27c4.75,2.71,7.63,7.87,9.16,13.12A26.52,26.52,0,0,1,91,349.94a17.91,17.91,0,0,1-5.18,10"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.19,399.7c6.44,1.42,11.74,6,18,8.17,4.11,1.46,8.75,2,12,4.85-.79-2-2.66-3.31-4.47-4.45a79.9,79.9,0,0,0-16.27-7.76c-2.93-1-6.1-1.86-9.07-1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.88,405.44c-8.06-.13-16.55-7-24.58-7.41,8.4-2.71,20.43-.49,24.58,7.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,386.1a26.17,26.17,0,0,1,12.89-.88,78.81,78.81,0,0,1,12.58,3.42c-.41-2.8-2.68-4.9-4.81-6.76a32.65,32.65,0,0,0-5-3.89,11.28,11.28,0,0,0-6.06-1.71,9.57,9.57,0,0,0-6.69,3.37A11.06,11.06,0,0,0,87,386.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.49,377.19c-5.08-4.33-12.77-3.91-19.44-3.76a158.23,158.23,0,0,1,30.14,18.79C81.46,387.5,76.9,382.67,70.49,377.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.49,377.19c-5.08-4.33-12.77-3.91-19.44-3.76a158.23,158.23,0,0,1,30.14,18.79C81.46,387.5,76.9,382.67,70.49,377.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M89.32,371.21a57.22,57.22,0,0,1,7.8-4.54c2.68-1.21,5.17-3.14,7.75-4.54,3.35-1.81,6.24-4.33,9.32-6.58s6.44-4.27,10.2-4.87a20.17,20.17,0,0,0-9.29.54,59.19,59.19,0,0,0-8.74,3.4c-4,1.78-8,3.61-11.22,6.51s-6.16,5.75-5.82,10.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,405.44a1,1,0,0,1-.26-.11L110,405c-.61-.32-1.48-.8-2.58-1.35-.54-.29-1.14-.59-1.8-.89s-1.35-.64-2.09-1a30.11,30.11,0,0,0-5-1.73,10.59,10.59,0,0,0-5.17-.13,15.31,15.31,0,0,0-2.19.65,11.24,11.24,0,0,0-4,2.75c-.47.5-.7.8-.72.79l.15-.24a7.14,7.14,0,0,1,.49-.63,10.11,10.11,0,0,1,2.19-1.93,11.12,11.12,0,0,1,1.79-1,14.83,14.83,0,0,1,2.22-.69,10.74,10.74,0,0,1,5.3.11,29.37,29.37,0,0,1,5,1.76c.74.33,1.44.66,2.09,1s1.25.63,1.79.93c1.09.58,1.94,1.08,2.54,1.44l.67.41A1.14,1.14,0,0,1,111,405.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,401.44a2,2,0,0,1,.51.15,11.33,11.33,0,0,1,1.31.57,16.3,16.3,0,0,1,3.85,2.73,16.08,16.08,0,0,1,2.89,3.74,12.48,12.48,0,0,1,.62,1.29,1.8,1.8,0,0,1,.17.5s-.35-.66-1-1.68a18.13,18.13,0,0,0-2.91-3.64,18.53,18.53,0,0,0-3.75-2.76C78.55,401.76,77.85,401.49,77.87,401.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,376.79a1.3,1.3,0,0,1,.34.1l1,.34,1.53.57c.59.22,1.24.54,2,.87a46.59,46.59,0,0,1,10.5,6.68,52.08,52.08,0,0,1,4.89,4.82,55.34,55.34,0,0,1,3.48,4.41c.92,1.3,1.61,2.39,2.09,3.14l.55.86a1.54,1.54,0,0,1,.18.31l-.22-.27c-.14-.19-.35-.47-.6-.84-.51-.73-1.23-1.8-2.17-3.08s-2.12-2.77-3.51-4.35a53,53,0,0,0-4.88-4.78,49.27,49.27,0,0,0-10.4-6.72c-.72-.33-1.36-.67-2-.91l-1.5-.6-.95-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.13,381.56a2.77,2.77,0,0,1-.64-.08l-.74-.14c-.29,0-.62,0-1-.09a10,10,0,0,0-8.06,3,10.89,10.89,0,0,0-1.62,2A17.36,17.36,0,0,0,86,388.33a2.3,2.3,0,0,1,.16-.63,9.55,9.55,0,0,1,.77-1.59A11.05,11.05,0,0,1,88.51,384a9.92,9.92,0,0,1,2.57-1.94,9.81,9.81,0,0,1,5.7-1c.37.05.71.06,1,.13l.74.19A2.88,2.88,0,0,1,99.13,381.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.24,356.42l-.31.19-.9.49c-.78.42-1.9,1-3.27,1.85s-3,1.82-4.67,3a38.89,38.89,0,0,0-5.22,4.37,12.84,12.84,0,0,0-2.13,2.76c-.53,1-1,2-1.5,2.93a55.05,55.05,0,0,0-2.24,5.1,29.81,29.81,0,0,0-1.09,3.6c-.21.86-.28,1.34-.31,1.34a1.64,1.64,0,0,1,0-.36c0-.23.08-.57.17-1a26.11,26.11,0,0,1,1-3.63A49.48,49.48,0,0,1,89,371.94c.46-.95,1-1.93,1.49-2.95a13.25,13.25,0,0,1,2.17-2.83,38.53,38.53,0,0,1,5.27-4.39c1.73-1.21,3.35-2.2,4.73-3s2.52-1.38,3.32-1.77l.93-.44A1.44,1.44,0,0,1,107.24,356.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.63,380.84a3,3,0,0,1-.16-.68l-.35-1.87a48.1,48.1,0,0,0-3.83-11.85l-.79-1.72a4.56,4.56,0,0,1-.26-.65,2.62,2.62,0,0,1,.36.6c.22.39.52,1,.87,1.68a41.26,41.26,0,0,1,2.39,5.8,41.79,41.79,0,0,1,1.46,6.11c.12.79.21,1.43.26,1.88A3.32,3.32,0,0,1,84.63,380.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,362.49a21.71,21.71,0,0,0-2.62-8.7,28.74,28.74,0,0,0-19.48-14.53l18,26.88,2.33,4.79A13.76,13.76,0,0,0,84,362.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.98,
    y: 415.46,
    width: 41.93,
    height: 7.43,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.11 421.42 74.68 444.48 102.52 444.48 106.78 421.42 71.11 421.42",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.89,422.9c0,.08-9.46.15-21.12.15s-21.13-.07-21.13-.15,9.46-.15,21.13-.15S109.89,422.82,109.89,422.9Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Texts--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.59,72.43,246,69.15a10.27,10.27,0,0,0,5.93,2c2.47,0,3.48-.86,3.48-2C255.42,65.58,245,68,245,61c0-3.19,2.47-5.85,7.59-5.85a11.66,11.66,0,0,1,6.24,1.66l-1.28,3.31a9.8,9.8,0,0,0-5-1.48c-2.47,0-3.42,1-3.42,2.15,0,3.46,10.46,1.07,10.46,8,0,3.14-2.49,5.83-7.63,5.83A12.53,12.53,0,0,1,244.59,72.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.1,67.05a7.6,7.6,0,1,1,7.61,7.44A7.25,7.25,0,0,1,261.1,67.05Zm11.13,0c0-2.49-1.52-4-3.52-4s-3.55,1.51-3.55,4,1.54,4,3.55,4S272.23,69.55,272.23,67.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.55,59.62v3.86c-.33,0-.59,0-.9,0-2.21,0-3.67,1.26-3.67,4v6.82h-4V59.83h3.84v1.91A5.46,5.46,0,0,1,287.55,59.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.53,59.62v3.86c-.33,0-.59,0-.9,0-2.21,0-3.68,1.26-3.68,4v6.82h-4V59.83h3.83v1.91A5.49,5.49,0,0,1,298.53,59.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.14,59.83l-6.25,15.33c-1.33,3.5-3.24,4.54-5.73,4.54a6,6,0,0,1-3.86-1.31l1.47-3a3.46,3.46,0,0,0,2.26.91c1.11,0,1.72-.51,2.26-1.8l0-.13-6-14.56h4.14l3.89,9.8,3.9-9.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,71.86a6.48,6.48,0,0,1-.69,2.69l-1.47,3.86h-2.54l1.13-4.27A2.33,2.33,0,0,1,315,71.86a2.48,2.48,0,1,1,5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.86,62.3c0,4.19-3,6.8-7.81,6.8h-3.63v5.18h-4.16V55.48h7.79C342.86,55.48,345.86,58.08,345.86,62.3Zm-4.21,0c0-2.07-1.29-3.28-3.83-3.28h-3.4v6.53h3.4C340.36,65.55,341.65,64.34,341.65,62.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.65,66v8.25h-3.76v-1.8c-.74,1.31-2.18,2-4.21,2-3.24,0-5.17-1.88-5.17-4.37s1.72-4.33,5.94-4.33h3.19c0-1.8-1-2.84-3.19-2.84a6.48,6.48,0,0,0-4,1.34L348,61.36a10.31,10.31,0,0,1,6-1.74C358.2,59.62,360.65,61.66,360.65,66Zm-4,3.68V68.24h-2.76c-1.87,0-2.46.72-2.46,1.69s.84,1.74,2.26,1.74A3,3,0,0,0,356.64,69.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.69,59.83v12c0,5.37-2.77,7.84-7.76,7.84a11.09,11.09,0,0,1-6.79-2l1.6-3a8,8,0,0,0,4.88,1.64c2.83,0,4.06-1.35,4.06-3.95v-.62a5.56,5.56,0,0,1-4.37,1.8,7,7,0,0,1,0-14,5.46,5.46,0,0,1,4.58,2.06V59.83Zm-3.95,6.77a3.64,3.64,0,1,0-3.63,3.54A3.43,3.43,0,0,0,374.74,66.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.89,68.24H385.43a3.72,3.72,0,0,0,4,2.9,4.59,4.59,0,0,0,3.47-1.4L395,72.16a7.07,7.07,0,0,1-5.7,2.33c-4.79,0-7.9-3.14-7.9-7.44a7.19,7.19,0,0,1,7.38-7.43c4.06,0,7.2,2.84,7.2,7.49C396,67.43,395.92,67.89,395.89,68.24Zm-10.51-2.45h6.81a3.43,3.43,0,0,0-6.81,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.06,66v8.27h-4V66.65c0-2.34-1-3.41-2.8-3.41-1.93,0-3.32,1.24-3.32,3.89v7.15h-4V59.83h3.83v1.69a5.94,5.94,0,0,1,4.58-1.9C417.59,59.62,420.06,61.6,420.06,66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.81,67.05a7.6,7.6,0,1,1,7.61,7.44A7.26,7.26,0,0,1,422.81,67.05Zm11.13,0c0-2.49-1.51-4-3.52-4s-3.55,1.51-3.55,4,1.55,4,3.55,4S433.94,69.55,433.94,67.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,73.58a5.52,5.52,0,0,1-3.26.91c-3.27,0-5.17-1.74-5.17-5.18V63.37H439V60.15h2.14V56.63h4v3.52h3.44v3.22h-3.44v5.89c0,1.23.64,1.9,1.72,1.9a2.69,2.69,0,0,0,1.62-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.54,60.15h3.54v3.22h-3.44V74.28h-4V63.37h-2.14V60.15h2.14v-.64c0-3.25,1.9-5.37,5.35-5.37a5.49,5.49,0,0,1,3.06.78L467,58a2.74,2.74,0,0,0-1.62-.51c-1.18,0-1.82.67-1.82,2.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.88,67.05a7.6,7.6,0,1,1,7.61,7.44A7.26,7.26,0,0,1,467.88,67.05Zm11.13,0c0-2.49-1.51-4-3.52-4s-3.55,1.51-3.55,4,1.55,4,3.55,4S479,69.55,479,67.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.69,59.83V74.28h-3.81V72.56a5.49,5.49,0,0,1-4.29,1.93c-3.47,0-5.92-2-5.92-6.5V59.83h4v7.55c0,2.41,1,3.49,2.81,3.49s3.18-1.24,3.18-3.9V59.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.55,66v8.27h-4V66.65c0-2.34-1-3.41-2.8-3.41-1.93,0-3.32,1.24-3.32,3.89v7.15h-4V59.83h3.83v1.69a5.94,5.94,0,0,1,4.58-1.9C515.09,59.62,517.55,61.6,517.55,66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.42,54.35V74.28h-3.83V72.61a5.19,5.19,0,0,1-4.32,1.88c-3.91,0-6.91-2.9-6.91-7.44s3-7.43,6.91-7.43a5.2,5.2,0,0,1,4.14,1.74v-7Zm-3.93,12.7c0-2.49-1.54-4-3.52-4s-3.55,1.51-3.55,4,1.54,4,3.55,4S531.49,69.55,531.49,67.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.53,72.05a2.47,2.47,0,0,1,4.94,0,2.47,2.47,0,0,1-4.94,0Zm.08-16.57h4.78l-.8,12.27h-3.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.28,
    y: 93.27,
    width: 148.01,
    height: 28.77,
    rx: 14.39,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.61,106.84h1.67v3.35a5.31,5.31,0,0,1-3.19,1,4.27,4.27,0,1,1,3.34-7.12l-1.17,1.14a2.63,2.63,0,0,0-2.05-.93,2.64,2.64,0,0,0,0,5.28,2.77,2.77,0,0,0,1.42-.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,107.92a3.34,3.34,0,1,1,3.34,3.27A3.18,3.18,0,0,1,353.4,107.92Zm4.89,0a1.57,1.57,0,1,0-1.55,1.76A1.57,1.57,0,0,0,358.29,107.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.36,110.79a2.43,2.43,0,0,1-1.43.4,2,2,0,0,1-2.27-2.28v-2.6h-.94v-1.42h.94v-1.54h1.76v1.54h1.51v1.42h-1.51v2.58c0,.54.28.84.75.84a1.17,1.17,0,0,0,.71-.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.71,107.92a3.34,3.34,0,1,1,3.34,3.27A3.18,3.18,0,0,1,368.71,107.92Zm4.89,0a1.57,1.57,0,1,0-1.55,1.76A1.57,1.57,0,0,0,373.6,107.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.12,102.84v8.26h-1.83v-3.39H381.7v3.39h-1.83v-8.26h1.83v3.25h3.59v-3.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.42,107.92a3.34,3.34,0,1,1,3.34,3.27A3.18,3.18,0,0,1,388.42,107.92Zm4.89,0a1.57,1.57,0,1,0-1.55,1.76A1.57,1.57,0,0,0,393.31,107.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.53,107.46v3.64h-1.76v-3.35c0-1-.44-1.5-1.15-1.5s-1.35.53-1.35,1.66v3.19h-1.76v-3.35c0-1-.42-1.5-1.15-1.5s-1.33.53-1.33,1.66v3.19h-1.76v-6.35H398v.73a2.41,2.41,0,0,1,1.91-.82,2.26,2.26,0,0,1,2,1,2.66,2.66,0,0,1,2.19-1C405.49,104.66,406.53,105.53,406.53,107.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.09,108.44H409.5a1.63,1.63,0,0,0,1.74,1.28,2,2,0,0,0,1.52-.62l.94,1.06a3.1,3.1,0,0,1-2.51,1,3.21,3.21,0,0,1-3.46-3.27,3.15,3.15,0,0,1,3.24-3.26,3.08,3.08,0,0,1,3.16,3.29A4.22,4.22,0,0,1,414.09,108.44Zm-4.61-1.07h3a1.47,1.47,0,0,0-1.49-1.32A1.45,1.45,0,0,0,409.48,107.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.92,107.92a3,3,0,0,1-3,3.27,2.33,2.33,0,0,1-1.83-.77v3H415.3v-8.63H417v.73a2.33,2.33,0,0,1,1.91-.82A3,3,0,0,1,421.92,107.92Zm-1.79,0a1.56,1.56,0,1,0-1.54,1.76A1.57,1.57,0,0,0,420.13,107.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.36,107.47v3.63h-1.64v-.79a2.33,2.33,0,0,1-4.12-1c0-1.12.75-1.9,2.6-1.9h1.4c0-.79-.45-1.25-1.4-1.25a2.82,2.82,0,0,0-1.75.59l-.63-1.29a4.57,4.57,0,0,1,2.62-.76C427.29,104.66,428.36,105.55,428.36,107.47Zm-1.76,1.62v-.65h-1.2c-.83,0-1.09.32-1.09.74s.37.77,1,.77A1.29,1.29,0,0,0,426.6,109.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.29,104.75V110c0,2.36-1.22,3.45-3.41,3.45a4.9,4.9,0,0,1-3-.87l.7-1.33a3.51,3.51,0,0,0,2.14.72c1.25,0,1.79-.59,1.79-1.73V110a2.45,2.45,0,0,1-1.92.79,3.07,3.07,0,0,1,0-6.13,2.39,2.39,0,0,1,2,.9v-.81Zm-1.74,3a1.6,1.6,0,0,0-3.19,0,1.6,1.6,0,0,0,3.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.84,108.44h-4.59a1.63,1.63,0,0,0,1.74,1.28,2,2,0,0,0,1.52-.62l.94,1.06a3.1,3.1,0,0,1-2.51,1,3.21,3.21,0,0,1-3.46-3.27,3.15,3.15,0,0,1,3.24-3.26,3.08,3.08,0,0,1,3.16,3.29A4.22,4.22,0,0,1,443.84,108.44Zm-4.61-1.07h3a1.47,1.47,0,0,0-1.49-1.32A1.45,1.45,0,0,0,439.23,107.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.33,251.9s-7.1-.22-11.09,3.9L613,266.13l10.94-2.19,1-3.46,1.75-6.57Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.34,242.88s3.46,2.2,4.33,4.57,20.69,16.48,20.69,16.48l2.67-.72,31.89-9.78,8,14.4-39.47,14.82c-1.15.25-29.2-8.89-29.2-8.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.12,275.93l-24.28-7.74-10,31.31-33.66-10.73,10-31.32-80.3-25.61,7.4-23.22,100.46-72.16L628,148,534.17,216.9l40,12.78,8.9-27.91,32.6,10.39-8.9,27.91,24.28,7.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M622.12,275.93l-24.28-7.74-10,31.31-33.66-10.73,10-31.32-80.3-25.61,7.4-23.22,100.46-72.16L628,148,534.17,216.9l40,12.78,8.9-27.91,32.6,10.39-8.9,27.91,24.28,7.74Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M612.94,273.13l-24.29-7.74-10,31.31L545,286l10-31.32L474.69,229l7.41-23.22,100.45-72.16,36.22,11.55L525,214.1l40,12.77,8.9-27.9,32.59,10.39-8.9,27.91L621.91,245Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M549.87,253l-.32-9.79.82-4.82s9.25.26,11.22-3.1a51.69,51.69,0,0,0,3.61-8.63L553.69,224l-8.44,13.19-2.55,6.46,4,8.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M534.52,211.56A68.11,68.11,0,0,1,535.83,200a23.61,23.61,0,0,1,5-10.42c.39-.44,3.36-3.28,3.89-3,.38.19-1.87,3-1.81,3.45a20,20,0,0,1-2.08,11.7,53.05,53.05,0,0,1-6.3,9.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.15,239.53C548.16,237,549,235,549,235s9.15,2.49,13.08-6c1.89-4.1,5.11-12.87,7.94-20.84a17.46,17.46,0,0,0-9.32-21.76l-.83-.37c-9.12-3.46-17.16,2.36-20.37,11.58l-12.24,31.88,3.35,9.75a8.81,8.81,0,0,0,16.55.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549,235a22.68,22.68,0,0,1-9.66-8.27s-.06,7.43,8.81,10.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.7,214.27a1.33,1.33,0,0,1-1.72.7,1.27,1.27,0,0,1-.77-1.66,1.34,1.34,0,0,1,1.73-.71A1.28,1.28,0,0,1,561.7,214.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.6,210.84c-.23.09-.85-1-2.16-1.59s-2.57-.36-2.64-.59.24-.32.8-.43a3.72,3.72,0,0,1,2.2.26,3.56,3.56,0,0,1,1.63,1.47C566.69,210.45,566.7,210.8,566.6,210.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.6,209.78a1.33,1.33,0,0,1-1.72.7,1.27,1.27,0,0,1-.77-1.66,1.34,1.34,0,0,1,1.73-.71A1.28,1.28,0,0,1,550.6,209.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.16,205.83c-.22.09-.84-1-2.16-1.59s-2.57-.36-2.64-.58.24-.33.8-.44a3.65,3.65,0,0,1,2.2.27A3.54,3.54,0,0,1,554,205C554.26,205.44,554.26,205.79,554.16,205.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.69,217.81a10.3,10.3,0,0,1,2.3.57c.35.12.7.19.86,0a1.83,1.83,0,0,0,.22-1.09c0-1,.1-1.95.15-3,.25-4.25.59-7.69.76-7.68s.11,3.47-.14,7.72c-.07,1.05-.13,2-.2,3a2.14,2.14,0,0,1-.41,1.39.92.92,0,0,1-.77.24,2.65,2.65,0,0,1-.61-.17A9.32,9.32,0,0,1,553.69,217.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556,201.35c-.34.25-1.43-.7-2.95-1.47s-2.9-1.15-2.9-1.56c0-.2.42-.37,1.09-.38a5.49,5.49,0,0,1,2.49.64,5.57,5.57,0,0,1,2,1.67C556.09,200.8,556.18,201.23,556,201.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.26,206.07c-.36.19-1.13-.52-2.21-1s-2.1-.7-2.17-1.11c0-.19.25-.43.78-.53a3.47,3.47,0,0,1,2,.32,3.37,3.37,0,0,1,1.5,1.4C568.44,205.6,568.43,206,568.26,206.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.36,204.21c-.12-.13-5.1-4.37-7.53,1.56s4,7.14,4.11,7S537.36,204.21,537.36,204.21Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.05,209.76s-.14,0-.34,0a1.11,1.11,0,0,1-.78-.3,2.79,2.79,0,0,1-.25-2.78,3.76,3.76,0,0,1,.9-1.36,1.26,1.26,0,0,1,1.1-.47.55.55,0,0,1,.49.53c0,.2-.07.3,0,.32s.17,0,.22-.31a.73.73,0,0,0-.08-.46.86.86,0,0,0-.51-.39,1.59,1.59,0,0,0-1.46.48,3.72,3.72,0,0,0-1,1.5,2.92,2.92,0,0,0,.45,3.18,1.19,1.19,0,0,0,1,.23C533,209.9,533.06,209.78,533.05,209.76Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.1,196.72c1.17-.15-.47-4.42-2.41-6.44-2.93-3.05-8-6.23-11.66-6.61-4.42-.46-8.5.19-11.94,3a25.27,25.27,0,0,0-7.4,10.9,7.68,7.68,0,0,0-.61,4c.31,1.64,1.57,3.11.77,4.9a2.68,2.68,0,0,0-.1,2.06c.62,1.59,2.39,1,3.44.19,2.23-1.81,3.49-4.53,4.67-7.16a18.88,18.88,0,0,0,1.89-5.8c.1-1.11,0-2.23.17-3.33a3.91,3.91,0,0,1,1.61-2.81,4.3,4.3,0,0,1,.68-.29,6.64,6.64,0,0,1,6.62,1.29c2.88,2.52,7.89,6.57,9.84,6a9.82,9.82,0,0,0,3.74-1.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.87,222.51c0,.11-.34.22-.89.14a3.72,3.72,0,0,1-1.92-.94,3.76,3.76,0,0,1-1.1-1.83c-.12-.54,0-.89.07-.9s.57,1.14,1.63,2.08S553.88,222.26,553.87,222.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.67,171.07A50.66,50.66,0,0,1,553,177.3a50.13,50.13,0,0,1-4.11,5.94,50.09,50.09,0,0,1,3.67-6.22A52.66,52.66,0,0,1,556.67,171.07Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.71,355.43l18.6,17.66s-9,60.29-7.42,60.4l22.22,1.58s13.4-69.78,12.39-73.87S543,324.92,543,324.92l-.4-5.53-9.24-1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.76,331.29c1.8,4.07,4.8,8.9,5.42,12.95l11.33,41.24-40.35,49,18,15.09s48.61-52.46,50.3-58.92c1.35-5.15-4.08-57-4.08-57l1.78-14.8-42-10,0,.07A26.57,26.57,0,0,0,495.76,331.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.54,435.77l-13,15s10.05,17.67,7.9,20.67l-28.41-23,19.38-24.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.79,442.38a1.57,1.57,0,0,0-1.93.74,1.43,1.43,0,0,0,.61,1.91,1.68,1.68,0,0,0,2-.8,1.47,1.47,0,0,0-.87-1.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,448.43l2-2.36,26.47,23s.8,1.61-.1,2.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.11,451c-.13.14-.87-.35-1.94-.44s-1.92.24-2,.08.81-.84,2.09-.72S487.24,450.91,487.11,451Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,454.74c-.08.17-.88-.07-1.85.17s-1.64.78-1.78.66.45-1,1.67-1.29S489.14,454.6,489,454.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.68,459.88c-.15-.07.25-1,1.25-1.48s1.91-.3,1.87-.13-.78.27-1.6.7S487.83,460,487.68,459.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.71,447.28c-.16.09-.63-.63-1.46-1.21s-1.66-.81-1.63-1,1-.23,2,.47S489.88,447.22,489.71,447.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.24,422.89,563,443.14s19.43,7.14,19.73,10.89l-37.24.76-.84-31.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.44,441.67a1.61,1.61,0,0,0-1,1.85,1.47,1.47,0,0,0,1.74,1.08,1.69,1.69,0,0,0,1.06-2,1.5,1.5,0,0,0-1.92-.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.48,454.79l0-3.19,35.69.46s1.68.73,1.52,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.59,442.93c0,.19-.91.29-1.79.93s-1.34,1.45-1.51,1.38.08-1.19,1.16-1.94S563.62,442.75,563.59,442.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.53,444.55c.05.19-.73.53-1.33,1.35s-.76,1.69-1,1.68-.32-1.08.45-2.09S567.52,444.37,567.53,444.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.86,449.44c-.17,0-.44-.91,0-2s1.29-1.5,1.37-1.34-.44.73-.79,1.61S570,449.41,569.86,449.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.16,438.3c-.07.18-.91-.07-1.94,0s-1.82.45-1.92.29.66-.87,1.87-1S563.24,438.15,563.16,438.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.68,330.21a3.18,3.18,0,0,1,.1.54c.05.41.11.92.19,1.55.16,1.34.36,3.29.59,5.7.46,4.82,1,11.49,1.49,18.87s.87,14,1.18,18.88c.13,2.36.24,4.3.32,5.73l.06,1.56a2,2,0,0,1,0,.54,1.93,1.93,0,0,1-.09-.54c0-.41-.1-.92-.17-1.55-.12-1.42-.28-3.36-.48-5.71-.38-4.83-.83-11.51-1.33-18.88s-1-14-1.33-18.87c-.18-2.35-.32-4.29-.43-5.71,0-.63-.07-1.15-.1-1.56A2.11,2.11,0,0,1,536.68,330.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635,251.42c.79,1.5-2.31,2.85-2.31,2.85.72.59,0,3.14-1.26,3.25.53.41.91.45,1.15,1.08a2.15,2.15,0,0,1-.16,1.93,1.54,1.54,0,0,1-1.76.6,2.57,2.57,0,0,1,.19,2.9,2.51,2.51,0,0,1-1.45,1.08,2.6,2.6,0,0,1-.92.09,1,1,0,0,1-.35-.05l-.13-.1c-.17-.19-.31-.4-.49-.57l-.22-.19a4.85,4.85,0,0,0-1.12-.66,3.66,3.66,0,0,1-.58-.22,2.47,2.47,0,0,1-.28-.28,6.23,6.23,0,0,0-2.34-1,5,5,0,0,1-2.43-1.33,1.8,1.8,0,0,1,.08-2.5,1.22,1.22,0,0,1-1-1.3,1.77,1.77,0,0,1,1-1.38,3.27,3.27,0,0,1,1.75-.27,1.35,1.35,0,0,1-.81-1.69,2.07,2.07,0,0,1,1.55-1.28,4.88,4.88,0,0,1,2.08.08c.68.15,3.53.74,4.23.79l.71-1.85.1-.24c1.27-.16,1.64-.27,2.77-.34C633.83,250.74,634.64,250.8,635,251.42Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.17,267.67a2,2,0,0,1-1,1.34,4.12,4.12,0,0,1-2.49-.34s.48-1.93.48-1.93l.12-.48c-.13-.43-.94-.62-1.29-.9a1.52,1.52,0,0,1-.16-2.1,2.05,2.05,0,0,1,2.14-.59,3.19,3.19,0,0,1,1.77,1.46A4.44,4.44,0,0,1,628.17,267.67Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.84,261.19a27.13,27.13,0,0,0-5.05-1.72,26.67,26.67,0,0,0-5.21-1.2,26.24,26.24,0,0,0,5.06,1.72A25.66,25.66,0,0,0,630.84,261.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.55,257.55a15.23,15.23,0,0,0-4.56-1.66,14.69,14.69,0,0,0-4.8-.65,40.41,40.41,0,0,0,4.67,1.18A38.48,38.48,0,0,0,631.55,257.55Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.24,254a11,11,0,0,0-3.81-1.23,15.81,15.81,0,0,0-4-.55,14.13,14.13,0,0,0,3.85,1.08A21.87,21.87,0,0,0,632.24,254Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.19,266.46c.06,0,.26-.31.2-.92a3,3,0,0,0-1.15-1.94,5.91,5.91,0,0,0-2-1.06c-.64-.15-1,.24-.9.28s.34-.11.79.09a10.07,10.07,0,0,1,1.73,1.11,3.19,3.19,0,0,1,1.12,1.59C628.16,266.1,628.1,266.44,628.19,266.46Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.94,284.26a7.89,7.89,0,0,1,.09-1.49c.1-1,.23-2.41.38-4,.32-3.41.69-8.13.9-13.35s.2-10,.16-13.38c0-1.64-.05-3-.07-4.06a9.59,9.59,0,0,1,0-1.49,7.29,7.29,0,0,1,.17,1.48c.08,1,.16,2.34.23,4.06.15,3.43.2,8.17,0,13.41s-.64,10-1.05,13.36c-.21,1.71-.4,3.08-.55,4A7.63,7.63,0,0,1,544.94,284.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.42,223.3c-.91.51-17.92,8.82-21.53,12.88s-9.14,30.12-9.14,30.12l-4.06,23.07-3.17,34.26,53.15.6c2.1-4.69.73-9.56-1.75-14.48l4.13-54.2-.71-12.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.58,250.91s-8.93-3.81-9.84-9.47.2-7.16,1.69-9.55,28.66-31.34,28.66-31.34l13.27,10.91L521.19,234s2.83.43,1.89,4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.08,238.05a11.52,11.52,0,0,0,.13-1.28,2.86,2.86,0,0,0-.37-1.48,2.5,2.5,0,0,0-1.67-1.15l-.18,0,.12-.14,19.07-22.67,0,.34-13.28-10.9.35,0-5,5.4L506.55,223c-2.39,2.62-4.67,5.1-6.73,7.48a16.6,16.6,0,0,0-1.41,1.8,17.82,17.82,0,0,0-1.09,1.93,8.85,8.85,0,0,0-.72,4,18.34,18.34,0,0,0,.45,3.75,7.73,7.73,0,0,0,1.52,2.95,17.48,17.48,0,0,0,4,3.62,30.46,30.46,0,0,0,2.95,1.78l.79.42a1.41,1.41,0,0,1,.27.15,1,1,0,0,1-.29-.1l-.82-.37a26.79,26.79,0,0,1-3-1.71,17.62,17.62,0,0,1-4.12-3.61,8.11,8.11,0,0,1-1.61-3,18.55,18.55,0,0,1-.5-3.83,9.32,9.32,0,0,1,.73-4.19,15.66,15.66,0,0,1,2.53-3.84c2.06-2.4,4.32-4.89,6.71-7.52,4.77-5.24,10.07-11,15.65-16.94l5-5.39.17-.18.18.16,13.26,10.92.19.16-.16.18-19.27,22.5-.07-.17a2.63,2.63,0,0,1,1.78,1.27,3,3,0,0,1,.34,1.56,4.4,4.4,0,0,1-.14,1A1.3,1.3,0,0,1,523.08,238.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.88,177.3s-1.56-1.23-1.88,1.38,2.17,13,2.47,13,1.84,6,1.6,6.82-2.51,3.3-2.51,3.3l10.58,8.69,3.27-5.9a13.82,13.82,0,0,0,6.2-4.84c2.39-3.51,11.45-16.86,11.71-18.73s-1.63-2.12-3-.33-4.55,6-5.12,6.27-.91-.54-.6-1,6.26-10,6.82-11.78c.75-2.35-1.8-2.84-1.8-2.84s.89-2.48-.42-2.95-2.59.8-4,2.91-6.2,9-6.7,9.32-.89,0-.45-.94,6.25-9.38,6.23-10.57-.89-3.07-3.37-.56-8,13-8.85,13.9-3.36,3.77-4.33,3.46-3.28-3.34-3.79-5.48A5.19,5.19,0,0,0,528.88,177.3Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.88,177.3a3.79,3.79,0,0,1,1,.94,5.37,5.37,0,0,1,.84,1.49c.13.32.2.68.32,1a8.88,8.88,0,0,0,.48,1.13,13.24,13.24,0,0,0,1.59,2.43c.64.72,1.57,2.09,2.64,1a21.92,21.92,0,0,0,2.88-2.78,9.75,9.75,0,0,0,1.23-1.79l1.18-2c1.61-2.76,3.31-5.84,5.5-9a9.74,9.74,0,0,1,2-2.17,2.41,2.41,0,0,1,1.51-.54,1.52,1.52,0,0,1,1.2,1.13,3.3,3.3,0,0,1,.15.81,2.36,2.36,0,0,1-.08.45l-.15.38c-.22.48-.47.94-.72,1.41-.52.92-1.08,1.82-1.65,2.74l-3.55,5.6a1.47,1.47,0,0,0-.24.68c0,.11,0,.14.06.15a.26.26,0,0,0,.21,0l.1-.1.14-.16c.09-.1.17-.22.26-.33l.52-.68c.69-.94,1.38-1.89,2.06-2.86l4.16-6a9.94,9.94,0,0,1,1.27-1.42,2.77,2.77,0,0,1,1.83-.83,1.49,1.49,0,0,1,1,.38,1.53,1.53,0,0,1,.43,1,4.94,4.94,0,0,1-.29,2l-.19-.34a2.75,2.75,0,0,1,2,1.47,2.92,2.92,0,0,1-.3,2.44c-.7,1.43-1.5,2.78-2.3,4.16l-2.48,4.13-1.28,2.08-.33.51-.15.25a.33.33,0,0,0-.06.19.42.42,0,0,0,.11.35.21.21,0,0,0,.27,0,3.37,3.37,0,0,0,.45-.43l.47-.53.91-1.11c.58-.76,1.17-1.51,1.75-2.26s1.1-1.51,1.78-2.26a3.09,3.09,0,0,1,1.29-.81,1.36,1.36,0,0,1,1.55.42,1.83,1.83,0,0,1,.2,1.55,4,4,0,0,1-.27.69c-.1.22-.2.44-.31.64-.43.83-.9,1.63-1.38,2.41-.94,1.57-1.92,3.11-2.89,4.61q-2.92,4.51-5.8,8.72c-.48.7-.92,1.4-1.44,2.08a13.81,13.81,0,0,1-1.74,1.84,14.77,14.77,0,0,1-4.2,2.55l.13-.11-3.28,5.89-.13.23-.2-.16-10.55-8.72-.16-.12.14-.15a30.2,30.2,0,0,0,2-2.36,5.83,5.83,0,0,0,.39-.62.93.93,0,0,0,.12-.62,13.12,13.12,0,0,0-.2-1.42c-.18-.94-.39-1.84-.62-2.71-.11-.43-.23-.86-.36-1.27q-.11-.31-.21-.6c0-.09-.09-.2-.12-.25h0s.14,0,.05,0a.26.26,0,0,1-.15-.09l0,0-.07-.17a46.17,46.17,0,0,1-1.17-4.58c-.3-1.41-.55-2.71-.74-3.89-.35-2.32-.65-4.25-.06-5.44a1.05,1.05,0,0,1,.61-.57,1,1,0,0,1,.61,0,1.22,1.22,0,0,1,.42.25s-.14-.1-.44-.2a1,1,0,0,0-.56,0,.93.93,0,0,0-.55.54c-.53,1.14-.21,3,.17,5.36a70.85,70.85,0,0,0,2,8.39.67.67,0,0,0,.06.12v0s-.09,0-.09.06,0,.17,0-.09h0l.1,0,0,.05a2,2,0,0,1,.17.32c.08.21.15.42.22.63.13.42.26.84.38,1.28.23.87.45,1.78.64,2.73a11.15,11.15,0,0,1,.21,1.46,2.66,2.66,0,0,1,0,.4,1.34,1.34,0,0,1-.15.4,4.88,4.88,0,0,1-.41.66,26.33,26.33,0,0,1-2,2.41l0-.27,10.6,8.67-.33.06c1-1.9,2.13-3.87,3.26-5.9l0-.07.08,0a14.16,14.16,0,0,0,4-2.48,12.69,12.69,0,0,0,1.66-1.77c.49-.64,1-1.37,1.43-2.07,1.9-2.8,3.84-5.71,5.78-8.71q1.46-2.26,2.87-4.6c.47-.78.94-1.58,1.36-2.39.11-.2.21-.4.3-.61a3.26,3.26,0,0,0,.24-.6,1.33,1.33,0,0,0-.12-1.13.87.87,0,0,0-1-.23,2.56,2.56,0,0,0-1.06.69c-.59.65-1.16,1.47-1.74,2.2s-1.17,1.51-1.76,2.27c-.3.38-.6.75-.91,1.12l-.49.56a3.06,3.06,0,0,1-.61.54.73.73,0,0,1-.86-.14,1,1,0,0,1-.26-.77.93.93,0,0,1,.12-.4l.17-.27.33-.51L553.1,183c.84-1.38,1.66-2.76,2.48-4.12s1.6-2.74,2.28-4.12a2.4,2.4,0,0,0,.3-2,2.27,2.27,0,0,0-1.61-1.17l-.28-.06.09-.27a4.55,4.55,0,0,0,.27-1.77,1.11,1.11,0,0,0-.28-.7,1.08,1.08,0,0,0-.69-.24,2.38,2.38,0,0,0-1.5.7,9.72,9.72,0,0,0-1.21,1.35l-4.16,6c-.68,1-1.37,1.93-2.07,2.87l-.53.69-.28.35-.14.17-.22.19a.69.69,0,0,1-.62.06.6.6,0,0,1-.34-.56,1.86,1.86,0,0,1,.29-.92c1.21-2,2.45-3.78,3.59-5.61.57-.92,1.13-1.82,1.64-2.73.25-.45.5-.9.71-1.36l.14-.34a1.57,1.57,0,0,0,0-.3,2.39,2.39,0,0,0-.12-.7,1.09,1.09,0,0,0-.84-.85,2,2,0,0,0-1.23.46A9.68,9.68,0,0,0,546.9,170c-2.19,3.08-3.91,6.15-5.54,8.9-.41.68-.8,1.35-1.19,2a10.33,10.33,0,0,1-1.28,1.83,22.45,22.45,0,0,1-2.95,2.79,2.7,2.7,0,0,1-.86.44.84.84,0,0,1-.52,0,2.65,2.65,0,0,1-.4-.24,8,8,0,0,1-1.18-1.23A13.83,13.83,0,0,1,531.4,182a9.11,9.11,0,0,1-.47-1.16c-.11-.38-.18-.73-.3-1a5.06,5.06,0,0,0-.79-1.48,4.73,4.73,0,0,0-.7-.77A2.12,2.12,0,0,1,528.88,177.3Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.24,234.1a34.92,34.92,0,0,1-5.19,7.36,12.05,12.05,0,0,1-7.95,3.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.1,245.28c0-.1,1-.1,2.54-.63a13.74,13.74,0,0,0,5.22-3.38,30.09,30.09,0,0,0,3.87-5,16.14,16.14,0,0,1,1.51-2.18,11.74,11.74,0,0,1-1.19,2.37,24.69,24.69,0,0,1-3.82,5.17,12.93,12.93,0,0,1-5.48,3.37,8.85,8.85,0,0,1-1.93.32A1.9,1.9,0,0,1,508.1,245.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.28,241.81a8.12,8.12,0,0,1-1.46,2,21.29,21.29,0,0,1-10,6.22,7.89,7.89,0,0,1-2.43.42,27.65,27.65,0,0,0,13.93-8.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M508.47,244.8c2.5.91,4.88,1.25,7.29.14a10.34,10.34,0,0,0,5.3-5.69c.68-1.81.84-3.81,1.64-5.58,1.79-3.93,6.47-6.19,7.53-10.37-3.73,4.08-7.23,7.73-10.12,12.62a23,23,0,0,1-5.31,6.29,10.81,10.81,0,0,1-6.46,2.6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M546,274l2.34.69s.9-17.46-1.59-22.75Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.55,228.22l-6.69-37.29c-2-9.23,1.76-18.06,11-19.77l.87-.11a16.86,16.86,0,0,1,18.59,13.3c1.66,8,3.39,16.87,3.88,21.21,1,9-7.8,11.51-7.8,11.51s.85,5.44,1.29,8.05l3.12,5.77-7.64-.56Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.43,217.07a21.82,21.82,0,0,1-12.12-2s3.65,6.4,12.51,4.48Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.89,193.09a1.29,1.29,0,0,1-1.08,1.45,1.24,1.24,0,0,1-1.46-1,1.28,1.28,0,0,1,1.07-1.44A1.23,1.23,0,0,1,337.89,193.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.94,188.56c-.14.18-1.2-.41-2.58-.24s-2.31,1-2.48.84,0-.38.44-.76a3.58,3.58,0,0,1,2-.88,3.38,3.38,0,0,1,2.08.4C338.82,188.19,339,188.47,338.94,188.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,194.64a1.3,1.3,0,0,1-1.07,1.45,1.25,1.25,0,0,1-1.47-1,1.28,1.28,0,0,1,1.07-1.45A1.24,1.24,0,0,1,325.67,194.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.45,190.56c-.14.19-1.2-.41-2.58-.23s-2.3,1-2.47.84,0-.39.44-.76a3.45,3.45,0,0,1,2-.88,3.36,3.36,0,0,1,2.08.39C325.34,190.19,325.52,190.48,325.45,190.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.72,200.55a9.46,9.46,0,0,1,2.19-.69c.35-.08.68-.19.7-.44a1.74,1.74,0,0,0-.36-1l-1.38-2.55c-1.92-3.64-3.36-6.65-3.21-6.73a48.6,48.6,0,0,1,3.75,6.45l1.33,2.58a2.09,2.09,0,0,1,.36,1.36.89.89,0,0,1-.52.58,2.18,2.18,0,0,1-.59.16A9,9,0,0,1,331.72,200.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,186.19c-.14.38-1.53.17-3.16.34s-3,.59-3.18.25c-.09-.16.15-.52.68-.87a5.25,5.25,0,0,1,2.37-.78,5.3,5.3,0,0,1,2.46.33C325.12,185.71,325.42,186,325.36,186.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.49,184.49c-.24.36-1.41.19-2.76.36s-2.46.56-2.77.27c-.13-.14,0-.48.46-.85a4.37,4.37,0,0,1,2.17-.82,4.18,4.18,0,0,1,2.28.32C338.4,184,338.6,184.32,338.49,184.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.42,197.48c-.16,0-6.4-1-5.44,5.06s6.9,3.89,6.89,3.71S311.42,197.48,311.42,197.48Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.63,204.23s-.09.09-.26.2a1,1,0,0,1-.79.14A2.65,2.65,0,0,1,308,202.4a3.57,3.57,0,0,1,.06-1.57,1.23,1.23,0,0,1,.67-1,.55.55,0,0,1,.67.2c.11.16.09.28.13.29s.11-.12,0-.37a.64.64,0,0,0-.3-.34.79.79,0,0,0-.61-.07,1.51,1.51,0,0,0-1,1.13,3.68,3.68,0,0,0-.11,1.76,2.81,2.81,0,0,0,2,2.39,1.14,1.14,0,0,0,1-.31C310.65,204.38,310.66,204.24,310.63,204.23Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.56,202.11c.21,0,.45,1.36,1.82,2.15s2.83.37,2.88.57-.29.33-.92.45a3.45,3.45,0,0,1-2.38-.4,3.07,3.07,0,0,1-1.44-1.81C327.37,202.5,327.46,202.12,327.56,202.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.33,174.27a1.44,1.44,0,0,0-.81-.74,4.46,4.46,0,0,0-2.35,0,13,13,0,0,1-5.81-.54,6.55,6.55,0,0,0,1.47-1.41,3.9,3.9,0,0,0,.51-4,.85.85,0,0,0-.57-.51c-.42-.07-.71.38-.94.73a3.32,3.32,0,0,1-2.9,1.8,5.27,5.27,0,0,1-2.43-.33l-.09-.07-1.08-.8h0a20.38,20.38,0,0,0-7-3.7,21,21,0,0,0-11.23.85c-3,1.3-5.39,4.26-5.32,7.51-2-1.2-4.6-.78-6.59.4h-.06c-2.24,1.21-3.19,3.92-3.52,6.44,0,.14,0,.28,0,.42a9.65,9.65,0,0,1-2.71,3.61c-.21.16-.44.37-.43.64s.27.44.5.56a4.72,4.72,0,0,0,2,.5,10.18,10.18,0,0,1-.52,1.79c-.2.49-.43,1.08-.13,1.52a1,1,0,0,0,1.12.29,3,3,0,0,0,1-.67c-.17.67-.34,1.35-.5,2a5.66,5.66,0,0,0,2.55-.57c.85,2.18,1.88,6.3,2.7,7.74,1.62-.22,2-.46,2.85-.31,1.12.18,1,2.12,2.3,1.38.66-.38,1.32-3.21,1.45-4a35.26,35.26,0,0,0-.79-15,11.42,11.42,0,0,1,3.08-3l-.09.11c2.37-1.25,5.06-2.55,7.62-1.74,2,.63,3.36,2.37,5,3.68A13,13,0,0,0,339.72,182c.77,2.64,1.56,7,2.08,9.54l1.37-5.37v0a10,10,0,0,0,.32-1l0-.1h0c.15-.51.29-1,.49-1.54l0,0a1.59,1.59,0,0,0,2-2.46,3.52,3.52,0,0,0-.88-.65,2.55,2.55,0,0,0,2.47.25,2,2,0,0,0,1.08-2.15,1.68,1.68,0,0,0-1.2-1.18,5.71,5.71,0,0,0,3.09-1.2C351.14,175.71,351.67,175,351.33,174.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,173.65a7.92,7.92,0,0,0-.77,1,6.51,6.51,0,0,0-.91,3.19,10.92,10.92,0,0,0,.12,2.31c.13.82.33,1.7.54,2.62a24.91,24.91,0,0,1,.52,2.92,10.36,10.36,0,0,1,0,1.58,3.19,3.19,0,0,1-.4,1.6,1.36,1.36,0,0,1-1.2.62,2,2,0,0,1-1.23-.46,4.77,4.77,0,0,1-1.22-2.15h.19a7.29,7.29,0,0,1-.8,2A2.66,2.66,0,0,1,309,190.1a1.7,1.7,0,0,1-.95,0,1.47,1.47,0,0,1-.72-.52,1.49,1.49,0,0,1-.31-.76,1.1,1.1,0,0,1,.18-.74l.1.07a5.83,5.83,0,0,1-1.69,1.74,5.73,5.73,0,0,1-.56.32l-.21.09a.7.7,0,0,1,.19-.12c.12-.08.31-.19.54-.35a6.09,6.09,0,0,0,1.62-1.75l.11.07a1.17,1.17,0,0,0,.15,1.34,1.34,1.34,0,0,0,.65.46,1.57,1.57,0,0,0,.86,0,2.55,2.55,0,0,0,1.48-1.15,7.55,7.55,0,0,0,.76-2l.08-.3.11.3a4.48,4.48,0,0,0,1.16,2,1.86,1.86,0,0,0,1.11.42,1.13,1.13,0,0,0,1-.53,3,3,0,0,0,.37-1.49,10,10,0,0,0,0-1.55,23.35,23.35,0,0,0-.5-2.9c-.21-.92-.4-1.8-.52-2.64a11.09,11.09,0,0,1-.1-2.34,6.47,6.47,0,0,1,1-3.22A3.81,3.81,0,0,1,315.7,173.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.74,178.07l-.06.07-.2.2c-.09.08-.2.19-.34.3a4.65,4.65,0,0,1-.5.37,8.07,8.07,0,0,1-3.72,1.28,10.25,10.25,0,0,1-5.72-1.15,17.89,17.89,0,0,1-5.47-4.63c-.82-1-1.52-2-2.26-2.95a11.54,11.54,0,0,0-2.43-2.41,6.06,6.06,0,0,0-2.82-1.17,4.52,4.52,0,0,0-1.38.06,4.69,4.69,0,0,0-1.21.43,5.25,5.25,0,0,0-2.5,2.88,5.81,5.81,0,0,0-.25,1.41s0,0,0-.09v-.28a5.21,5.21,0,0,1,.18-1.07,5.38,5.38,0,0,1,.79-1.51,5.26,5.26,0,0,1,1.72-1.47,4.82,4.82,0,0,1,1.24-.46,4.33,4.33,0,0,1,1.44-.07,6.28,6.28,0,0,1,2.92,1.18,12.39,12.39,0,0,1,2.47,2.44c.75.94,1.45,2,2.27,2.94a17.6,17.6,0,0,0,5.39,4.59,10.18,10.18,0,0,0,5.61,1.18,8.08,8.08,0,0,0,3.69-1.2C344.37,178.44,344.72,178,344.74,178.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,174a3.3,3.3,0,0,1-.29.27,6.44,6.44,0,0,1-.88.63,8.88,8.88,0,0,1-1.42.73,10.78,10.78,0,0,1-1.89.55,10.53,10.53,0,0,1-2,.17,9,9,0,0,1-1.59-.16,6.21,6.21,0,0,1-1.05-.27c-.24-.08-.37-.13-.36-.15s.54.14,1.43.27a10.34,10.34,0,0,0,1.57.11,10.1,10.1,0,0,0,1.92-.18,12.33,12.33,0,0,0,1.85-.52,10.15,10.15,0,0,0,1.43-.68C344.49,174.33,344.92,174,345,174Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.09,287.47l3.46-.55a18.66,18.66,0,0,1,3.58-2.82c2-1.16,3.73-1.16,4.23-.2a2.52,2.52,0,0,1-.76,3.07c-1,.95-4.92,2-5.14,3.65s12.33,7,12.33,7l-9.92,11.29-14.4-7.66-.66-1.18-.15-3.1Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.64,318.6,333,370l-1.47,8.93s-17.82,51.2-17.45,72.39l20.85-1s20.35-58,21.95-64.37,9.8-49.23,9.8-49.23l13.52,33.87.38,7.89-7.79,49.13L397,428.88s9.91-55.76,8.93-63-17-63.78-17-63.78l-8.26-7.21-47.11,8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.76,413.9,394,434.51s19.61,7.74,19.82,11.57L375.91,446l-.09-32.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.29,432.74a1.64,1.64,0,0,0-1.07,1.86,1.48,1.48,0,0,0,1.74,1.14,1.74,1.74,0,0,0,1.13-2c-.26-.75-1.27-1.35-1.94-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.91,446l.11-3.25L412.35,444s1.69.78,1.49,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.63,434.31c0,.2-.93.28-1.84.91s-1.4,1.44-1.57,1.36.11-1.2,1.22-1.94S394.67,434.13,394.63,434.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.61,436.06c0,.19-.76.52-1.39,1.34s-.82,1.7-1,1.69-.3-1.11.5-2.12S398.6,435.87,398.61,436.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.86,441.09c-.17,0-.43-.94.05-2s1.35-1.5,1.42-1.33-.45.73-.83,1.61S401,441.07,400.86,441.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.31,429.59c-.08.18-.93-.09-2,0s-1.86.42-2,.25.69-.86,1.93-.93S394.4,429.44,394.31,429.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.9,435.59l.15,23.67,5.51,18.68a2.43,2.43,0,0,1-1.8,3.06h0a2.42,2.42,0,0,1-2.15-.57c-3.71-3.36-17.3-15.77-17.21-17.51.1-2-1.81-24.95-1.81-24.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.76,481l-19.41-19.67,0,1a3.67,3.67,0,0,0,.94,2.34c1.55,1.72,5.94,6.38,16.22,15.76a2.44,2.44,0,0,0,2.22.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322,453.55a1.48,1.48,0,0,1,.45,1.91,1.41,1.41,0,0,1-1.88.47,1.54,1.54,0,0,1-.47-2,1.45,1.45,0,0,1,2-.27",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.05,470.82c.14.06.64-1.2,2-1.9a7.23,7.23,0,0,1,2.71-.6c0-.06-.28-.24-.84-.3a3.84,3.84,0,0,0-2.11.44,3.78,3.78,0,0,0-1.55,1.49C331,470.45,331,470.8,331.05,470.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,473.94a16.85,16.85,0,0,1,2.07-1.08,18.78,18.78,0,0,1,2.3-.37,2.72,2.72,0,0,0-2.47-.13C333.35,472.81,332.7,473.87,332.83,473.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.8,466.85a23.25,23.25,0,0,1,3.07-1.88,23.94,23.94,0,0,1,3.49-.92,6.61,6.61,0,0,0-6.56,2.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.15,459.66c.07.14,1.36-.45,3.06-.56s3.06.26,3.11.11a4.69,4.69,0,0,0-3.15-.63A4.75,4.75,0,0,0,327.15,459.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,452.71a12.2,12.2,0,0,1,3.17-.66,11.63,11.63,0,0,1,3.16.7c0-.06-.23-.34-.78-.64a5.27,5.27,0,0,0-4.75,0C327.17,452.37,326.9,452.66,326.93,452.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.47,229.36S292.79,237,302,255.3c11.23,22.4,21.92,53.91,25.59,56,1.5.85,8.55-2.68,8.55-2.68l5.59-10.36-14.83-38.74-9.68-22.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.72,223.42l-9.25,5.94L330,272.66l-3.55,38.68,5.55,3.14,57.29-7.94,1.86-2.59-6.29-18.17-8.38-20.4s-8.29-18.54-13.18-26.44-10.15-15.88-10.15-15.88l-14-1-1.72-1.91s-2.12,3.84-7.88,4.19c-4.69.29-14.64-2.25-14.64-2.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.09,287.47s-33.61-26.92-36.35-30.06-26.11-27.75-26.11-27.75-8.55-8.2-13.46-6.6c-6,2,6,30.9,6,30.9s24.72,20.52,28.73,24.42S416,297.78,416,297.78l5.71-.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.08,246.67a2.87,2.87,0,0,1,.25.51c.17.4.38.89.63,1.5.54,1.31,1.33,3.2,2.32,5.53,2,4.66,4.84,11,8,18.08s5.89,13.5,7.7,18.23c.91,2.36,1.61,4.29,2.06,5.63.2.63.37,1.14.51,1.55a2.17,2.17,0,0,1,.14.55,2,2,0,0,1-.24-.51l-.6-1.52c-.51-1.32-1.26-3.22-2.21-5.57-1.9-4.69-4.68-11.1-7.84-18.15s-6-13.45-7.85-18.15c-.95-2.35-1.69-4.26-2.17-5.6-.22-.62-.39-1.13-.54-1.53A2,2,0,0,1,320.08,246.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.22,235.72s.11.08.31.29a7.22,7.22,0,0,1,.73,1c.59.86,1.37,2.17,2.27,3.8,1.81,3.27,4.14,7.87,6.62,13s4.63,9.82,6.15,13.22c.76,1.71,1.37,3.09,1.77,4.06a11,11,0,0,1,.58,1.51,7.93,7.93,0,0,1-.77-1.43l-1.91-4L370.68,254c-2.47-5.13-4.76-9.75-6.47-13.05-.86-1.66-1.58-3-2.12-3.87S361.18,235.76,361.22,235.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M327.75,265s-2.39-13.33-1-21.12,5.35-19.13,5.35-19.13l7-3,36.45,17.71,2.7,3.27-4.83,15.35,3.6,28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.52,241.61c2.73-50.14,30.89-77.13,66.64-75.18,35.95,2,60.8,31.84,58.07,82s-30.68,77.14-66.64,75.18C358.84,321.64,333.78,291.76,336.52,241.61Zm90.83,4.95c1.88-34.51-9-49.47-25.81-50.39-16.63-.91-29.05,12.79-30.93,47.3s9,49.48,25.6,50.38C413.05,294.77,425.47,281.08,427.35,246.56Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M336.52,241.61c2.73-50.14,30.89-77.13,66.64-75.18,35.95,2,60.8,31.84,58.07,82s-30.68,77.14-66.64,75.18C358.84,321.64,333.78,291.76,336.52,241.61Zm90.83,4.95c1.88-34.51-9-49.47-25.81-50.39-16.63-.91-29.05,12.79-30.93,47.3s9,49.48,25.6,50.38C413.05,294.77,425.47,281.08,427.35,246.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M326.21,241.66c2.74-50.14,30.89-77.13,66.64-75.18,36,2,60.81,31.83,58.08,82s-30.69,77.14-66.64,75.18C348.53,321.69,323.48,291.8,326.21,241.66Zm90.83,5c1.89-34.51-9-49.48-25.81-50.39-16.63-.91-29.05,12.78-30.93,47.3s9,49.47,25.61,50.38C402.74,294.82,415.16,281.12,417,246.61Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,317.51l-6.21-3.78s-6.35-4.19-6.74-4.83a8.78,8.78,0,0,1-.79-3.27c0-.92,2.86-3,3.18-4.76s-1.57-3.5-2.25-3.8-1.38.75-1.53,1.53-1.29,1.92-3.08,2.32-4.25,2.73-4.25,2.73l-5.38,10.12c.92,1.73,11.94,5.85,12.28,6.05s12.09.42,13.26,0A1.89,1.89,0,0,0,364,317.51Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5,296.43c.06,1.69-3.32,1.58-3.32,1.58.4.83-1.35,2.83-2.54,2.39.31.59.63.79.57,1.46a2.11,2.11,0,0,1-1,1.67,1.54,1.54,0,0,1-1.85-.21,2.56,2.56,0,0,1-1.07,2.7,2.53,2.53,0,0,1-1.78.35,2.68,2.68,0,0,1-.87-.32,1,1,0,0,1-.29-.19.34.34,0,0,1-.07-.15c-.08-.24-.11-.49-.2-.72l-.12-.27a4.89,4.89,0,0,0-.73-1.08,4.47,4.47,0,0,1-.42-.45,2.35,2.35,0,0,1-.14-.37,6.17,6.17,0,0,0-1.66-1.94,4.85,4.85,0,0,1-1.62-2.24,1.8,1.8,0,0,1,1.14-2.23,1.23,1.23,0,0,1-.31-1.59,1.77,1.77,0,0,1,1.5-.81,3.31,3.31,0,0,1,1.69.51,1.35,1.35,0,0,1,0-1.88,2.09,2.09,0,0,1,1.94-.49,4.76,4.76,0,0,1,1.84,1c.55.42,2.87,2.18,3.48,2.53l1.44-1.36.19-.18c1.21.41,1.6.47,2.64.89C450.77,295.33,451.47,295.73,451.5,296.43Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.36,308.17a2,2,0,0,1-1.49.76,4.07,4.07,0,0,1-2.1-1.37S436,306,436,306l.31-.38c.07-.45-.57-1-.77-1.37a1.54,1.54,0,0,1,.76-2,2.09,2.09,0,0,1,2.19.4,3.17,3.17,0,0,1,1,2.08A4.44,4.44,0,0,1,438.36,308.17Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.57,303.47a27.25,27.25,0,0,0-3.82-3.73,26.75,26.75,0,0,0-4.18-3.33,51.59,51.59,0,0,0,8,7.06Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.77,300.49a14.91,14.91,0,0,0-3.39-3.46,15.09,15.09,0,0,0-4.06-2.66,42,42,0,0,0,3.71,3.08A39,39,0,0,0,445.77,300.49Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.93,297.58a11.06,11.06,0,0,0-2.91-2.75,15.7,15.7,0,0,0-3.34-2.2,14.22,14.22,0,0,0,3,2.63A21.86,21.86,0,0,0,447.93,297.58Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.9,307.08c0,.05.37-.17.58-.74a3,3,0,0,0-.2-2.25,5.83,5.83,0,0,0-1.32-1.8c-.52-.42-1-.21-.94-.14s.36.05.68.42a10.38,10.38,0,0,1,1.09,1.75,3.28,3.28,0,0,1,.32,1.92C439,306.75,438.84,307,438.9,307.08Z",
    style: {
      fill: "#6f4439"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.83,424.56l-3.22,19s19.08,7.79,19.24,11.53l-37.08-.56,4.65-31.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,441.72a1.6,1.6,0,0,0-1.07,1.81,1.45,1.45,0,0,0,1.68,1.14,1.69,1.69,0,0,0,1.13-1.92,1.49,1.49,0,0,0-1.88-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.77,454.56l.47-3.15,35.18,1.71s1.64.78,1.43,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.21,443.4c0,.19-.91.26-1.81.87s-1.39,1.39-1.55,1.31.12-1.17,1.22-1.88S215.26,443.23,215.21,443.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.08,445.16c0,.18-.75.5-1.38,1.29s-.81,1.65-1,1.64-.28-1.09.51-2.07S219.08,445,219.08,445.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,450.1c-.17,0-.4-.92.08-2s1.33-1.44,1.4-1.28-.46.71-.84,1.57S221.4,450.08,221.22,450.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,438.79c-.08.17-.9-.11-1.93-.05s-1.83.39-1.92.22.69-.83,1.89-.88S215,438.64,215,438.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.22,427.55l-9.84,17.59S168,460.62,166.47,464l-32.94-17,14.27-28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,438.37a1.6,1.6,0,0,0-1.77,1.14,1.46,1.46,0,0,0,1,1.77,1.7,1.7,0,0,0,1.86-1.22c.12-.77-.5-1.74-1.25-1.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.53,447l1.54-2.77,31,17.37s1.12,1.43.39,2.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,445.24c-.09.17-.94-.17-2,0s-1.86.63-2,.49.64-1,1.94-1.15S155.13,445.1,155,445.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.69,448.54c-.05.18-.9.11-1.81.54s-1.47,1.12-1.62,1,.23-1.11,1.38-1.63S157.77,448.37,157.69,448.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,453.92c-.16,0,0-1,.94-1.72s1.84-.7,1.83-.52-.72.43-1.45,1S157.57,454,157.4,453.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.83,441c-.15.12-.76-.49-1.71-.9s-1.8-.47-1.81-.65,1-.45,2.09.05S157,440.9,156.83,441Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.18,311.12s6.63,64.11,4.66,71.53-33.68,64.1-33.68,64.1l-21.91-12.17s26.64-51.33,26.3-53.5.71-8.34.71-8.34l-14.7-49.18,2.93-21.12,26-2.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,335.3c.66,2,35.93,42.23,35.93,42.23a4.26,4.26,0,0,0,.4,2.53,6.21,6.21,0,0,0,3,2.12l-14,58,24.49,2.26s14.61-58,14-65.35S198.12,313,198.12,313l-25-1.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.83,325.13a8.18,8.18,0,0,1-.25,1.59,25.9,25.9,0,0,0-.12,4.38,116.88,116.88,0,0,0,2.13,14.35,124.43,124.43,0,0,1,2.18,14.41,25.22,25.22,0,0,1-.08,4.43,8.16,8.16,0,0,1-.34,1.59,11,11,0,0,1,.14-1.61,30.91,30.91,0,0,0-.09-4.38c-.29-3.7-1.27-8.75-2.32-14.34a97.19,97.19,0,0,1-2-14.44,22,22,0,0,1,.28-4.42A9.94,9.94,0,0,1,187.83,325.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.09,226.38s4.47-7.18,8.56-7.82,11.17,0,11.17,0L256,234l-8.5,1.47Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.85 238.13 206.49 240.06 238.93 224.96 248.97 237.25 209.22 258.37 187.24 261.13 174.85 238.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.38,270.89l-25.1-4.4-5.67,32.38-34.8-6.09,5.67-32.38-83-14.53,4.2-24,89.8-85.06,37.44,6.55-83.63,80.93,41.41,7.24,5.05-28.85,33.69,5.9-5.05,28.85,25.11,4.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M273.38,270.89l-25.1-4.4-5.67,32.38-34.8-6.09,5.67-32.38-83-14.53,4.2-24,89.8-85.06,37.44,6.55-83.63,80.93,41.41,7.24,5.05-28.85,33.69,5.9-5.05,28.85,25.11,4.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,269.71l-25.11-4.39-5.67,32.37-34.8-6.09L205,259.22l-83-14.53,4.2-24L216,135.62l37.44,6.55L169.78,223.1l41.4,7.25,5-28.86,33.7,5.9-5.05,28.85,25.1,4.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.87,254.37s-3.63-9.78-6.84-13.55a104.46,104.46,0,0,1-6.75-9.23l16.16-7.12L184,218l-14.23,6.52-.85,12.78,17.17,17.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.08,189.63a13.11,13.11,0,0,1,4.66,11.23c-.19,2-.8,4.36.49,5.94s3.87,1.58,5.1,3.19c1.45,1.9.15,4.66.64,7a4.73,4.73,0,0,0,5,3.61,18.4,18.4,0,0,1-9.23,3.79l-2.49-3.34a3.4,3.4,0,0,1-.31,4.16A7.65,7.65,0,0,1,178,227.4a23.43,23.43,0,0,1-20.45-3.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.32,206.93a47.08,47.08,0,0,0,1.8-4.6c.81-3.45-.8-7.38.94-10.47,1.24-2.19,3.81-3.23,6.23-3.92s5-1.27,6.86-3c1.34-1.27,2.13-3,3.46-4.32,1.91-1.81,4.69-2.39,7.32-2.5a15.83,15.83,0,0,1,7.9,1.44,8.7,8.7,0,0,1,4.76,6.2,24.34,24.34,0,0,0,.38,3.93c.42,1.39,1.49,2.48,2.13,3.78a7,7,0,0,1-1.9,8.29l-19,23.58c-3.92,1.39-13.33-.57-16.28-3.51S138,210.86,139.32,206.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.77,198.69c-.66-5.45-4.67-11.95-10.09-11.07l-16.77,5.28a3.21,3.21,0,0,0-2.69,3.42l4.14,39.45s-1.25,1-2.05.66a.22.22,0,0,0-.27.33c1.94,3,11.14,15.84,21,12.15,2.19-.82-.08-7.72.23-10.26l-.17-6.49c-.15-3.32-.22-4.68-.22-4.64s6.92-1.56,7.85-10.77C180.15,212.17,179.5,204.75,178.77,198.69Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44,207a1.16,1.16,0,0,1-1.06,1.24,1.11,1.11,0,0,1-1.26-1,1.17,1.17,0,0,1,1.06-1.25A1.11,1.11,0,0,1,177.44,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08,207.53a1.17,1.17,0,0,1-1.06,1.24,1.13,1.13,0,0,1-1.27-1,1.18,1.18,0,0,1,1.06-1.25A1.12,1.12,0,0,1,166.08,207.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.94,203.2c-.13.21-1.21-.5-2.57-.33s-2.26,1.09-2.43.91,0-.44.41-.86a3.17,3.17,0,0,1,1.92-1,3.09,3.09,0,0,1,2.07.5C177.81,202.77,178,203.1,177.94,203.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.7,204c-.16.2-1.22-.6-2.68-.56s-2.52.84-2.68.65.08-.43.54-.81a3.61,3.61,0,0,1,2.14-.76,3.47,3.47,0,0,1,2.14.7C165.62,203.54,165.78,203.88,165.7,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.12,212.67a8.5,8.5,0,0,1,2-.49c.32-.05.62-.13.66-.35a1.6,1.6,0,0,0-.26-.94l-1.09-2.39a43.86,43.86,0,0,1-2.51-6.28,40.66,40.66,0,0,1,3,6.06l1.06,2.41a1.85,1.85,0,0,1,.23,1.25.78.78,0,0,1-.5.5,2,2,0,0,1-.54.11A8.31,8.31,0,0,1,170.12,212.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.84,227.52a23.27,23.27,0,0,1-12.4-2.57s3.43,6.23,12.51,4.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.21,216.26a2,2,0,0,1,.66-.75,1.57,1.57,0,0,1,1.09-.09,2.56,2.56,0,0,1,1.41.75,1.51,1.51,0,0,1,.33,1.51h0c-.15.53-.94.8-1.48.88a2.35,2.35,0,0,1-1.56-.36,1.37,1.37,0,0,1-.78-1A1.77,1.77,0,0,1,166.21,216.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.51,214.5c.2,0,.28,1.34,1.51,2.24s2.67.67,2.69.86-.31.29-.93.34a3.45,3.45,0,0,1-2.24-.64,3,3,0,0,1-1.18-1.89C166.28,214.84,166.41,214.5,166.51,214.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.69,200c-.11.34-1.37.25-2.84.52s-2.64.73-2.85.43c-.1-.14.09-.47.56-.83a4.73,4.73,0,0,1,2.08-.87,4.86,4.86,0,0,1,2.25.14C165.44,199.56,165.73,199.81,165.69,200Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,197.84c-.24.3-1.24.06-2.44.12s-2.19.32-2.44,0,0-.43.46-.73a3.76,3.76,0,0,1,2-.58,3.7,3.7,0,0,1,2,.46C176.92,197.41,177.07,197.7,177,197.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.19,194.14a7.49,7.49,0,0,1,3.85-2.45,83.83,83.83,0,0,1,19.4-4.53c.79,1.37,0,3.2-1.26,4.16a15.06,15.06,0,0,1-4.36,1.84,5.94,5.94,0,0,0-3.67,2.81c-.68,1.54-.17,3.39-.77,5-1,2.71-4.86,3.52-5.89,6.23-.77,2.06.39,4.28.64,6.46a7.83,7.83,0,0,1-7.87,8.77q-.45-11.76-.89-23.51C147.31,197.25,147.28,195.49,148.19,194.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,213.6c1.26-1.08,2.83-2,3.36-3.59.76-2.29-1-5,.19-7.12,1.13-1.9,4.34-1.74,5.39-3.68.82-1.51-.06-2.88.26-4.22a3.67,3.67,0,0,1,3.63-2.29l10.38,15.7c.89,5.22,1.84,8,.66,11a25.43,25.43,0,0,0-1.75,5,5,5,0,0,0,1.56,4.82c-6.4.38-12.33-3.08-17.8-6.43l-5.79-3.54a4.23,4.23,0,0,1-1.59-1.37C129.7,216.49,130.78,214.69,132,213.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.78,221.27a3.23,3.23,0,0,0,.68.15,5.92,5.92,0,0,0,2-.1,6.19,6.19,0,0,0,2.81-1.44,6.08,6.08,0,0,0,1.9-3.7,6.26,6.26,0,0,0-.16-2.46,10.12,10.12,0,0,0-1.14-2.4,9.34,9.34,0,0,1-1.18-2.49,3.21,3.21,0,0,1,.4-2.7c.6-.77,1.68-.94,2.69-1.32a2.87,2.87,0,0,0,1.38-1,2.82,2.82,0,0,0,.48-1.66,17.75,17.75,0,0,0-.67-3.35,3.73,3.73,0,0,1,0-1.63,2.27,2.27,0,0,1,.94-1.28,6.45,6.45,0,0,1,3.25-.8,7,7,0,0,0,3.32-.9,6.3,6.3,0,0,0,2.3-2.4,10,10,0,0,0,.89-3.05,14.07,14.07,0,0,1,.69-2.86,6.36,6.36,0,0,1,1.54-2.24,7.2,7.2,0,0,1,8.41-1,8.56,8.56,0,0,1,2.42,1.92,11.57,11.57,0,0,1,1.48,2.21s0-.06,0-.16-.11-.28-.22-.48a8.27,8.27,0,0,0-1.1-1.66,8.47,8.47,0,0,0-2.43-2,7.5,7.5,0,0,0-4.06-1,7.62,7.62,0,0,0-4.66,2,6.81,6.81,0,0,0-1.64,2.34,14.16,14.16,0,0,0-.71,2.92,10.15,10.15,0,0,1-.87,2.94,5.81,5.81,0,0,1-2.18,2.25,6.45,6.45,0,0,1-3.15.85,6.76,6.76,0,0,0-3.44.86,2.64,2.64,0,0,0-1.09,1.49,4.06,4.06,0,0,0,0,1.8,18.69,18.69,0,0,1,.66,3.28,2.51,2.51,0,0,1-.4,1.46,2.69,2.69,0,0,1-1.22.86c-.48.19-1,.32-1.5.52a3.05,3.05,0,0,0-1.33.92,3.45,3.45,0,0,0-.44,3,9.55,9.55,0,0,0,1.23,2.57,9.88,9.88,0,0,1,1.12,2.32,6,6,0,0,1-1.6,5.92,6.13,6.13,0,0,1-2.7,1.46A6.65,6.65,0,0,1,137.78,221.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,210.09a1.32,1.32,0,0,0-.22.52,2.32,2.32,0,0,0,.24,1.59,2.54,2.54,0,0,0,.8.88,2.71,2.71,0,0,0,1.36.39,3.2,3.2,0,0,0,2.84-1.73,4.25,4.25,0,0,0,.49-1.94,6.13,6.13,0,0,0-.41-2.12c-.48-1.39-1.37-2.76-1.36-4.37a3,3,0,0,1,.78-2.19,3.26,3.26,0,0,1,2.34-.68,7.84,7.84,0,0,0,2.78-.23,2.4,2.4,0,0,0,1.15-.94,3.37,3.37,0,0,0,.5-1.4,11.51,11.51,0,0,0-.18-2.84,6.25,6.25,0,0,1,.2-2.63,6.63,6.63,0,0,1,3.05-3.85,9.33,9.33,0,0,1,4.46-.92,13.27,13.27,0,0,0,4.05-.56,8.28,8.28,0,0,0,2.9-1.75,8.14,8.14,0,0,0,1.61-2,6.15,6.15,0,0,0,.8-2,10.46,10.46,0,0,1-.92,1.94,8.51,8.51,0,0,1-4.47,3.56,13.31,13.31,0,0,1-4,.5,9.54,9.54,0,0,0-4.61.93,7,7,0,0,0-3.24,4,6.84,6.84,0,0,0-.22,2.78,10.7,10.7,0,0,1,.18,2.75,2.39,2.39,0,0,1-1.42,2.05,7.69,7.69,0,0,1-2.64.21,3.54,3.54,0,0,0-2.58.79,3.24,3.24,0,0,0-.88,2.44,6.28,6.28,0,0,0,.53,2.39c.3.73.63,1.41.88,2.09a5.59,5.59,0,0,1,.41,2,3.92,3.92,0,0,1-.44,1.82,3,3,0,0,1-2.6,1.64,2.31,2.31,0,0,1-2.33-2.64A5,5,0,0,1,129.47,210.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.76,215.23a2.5,2.5,0,0,1,0,1.67,2.21,2.21,0,0,1-1.36,1.33,2.32,2.32,0,0,1-2.33-.69,2.11,2.11,0,0,1-.52-1.35,4.39,4.39,0,0,1,.27-1.61,9.42,9.42,0,0,0,1-3.66,5.17,5.17,0,0,0-1.87-3.73,5.93,5.93,0,0,0-2-1.09,8.76,8.76,0,0,0-2.27-.37,12.14,12.14,0,0,1-2.21-.27,2.94,2.94,0,0,1-1.7-1.11,3.54,3.54,0,0,1-.58-1.9,7.21,7.21,0,0,1,.2-2,14.7,14.7,0,0,0,.65-3.73,5.71,5.71,0,0,0-1.08-3.13,7.33,7.33,0,0,0-2.05-1.8,13.1,13.1,0,0,1-1.64-1.18,4.05,4.05,0,0,1-1-1.37s0,0,0,.12a2.3,2.3,0,0,0,.12.31,3.61,3.61,0,0,0,.78,1.05,12.27,12.27,0,0,0,1.62,1.25,7,7,0,0,1,1.95,1.78,5.36,5.36,0,0,1,1,3,15.46,15.46,0,0,1-.67,3.65,7.66,7.66,0,0,0-.23,2.06,4,4,0,0,0,.64,2.09,3.28,3.28,0,0,0,1.91,1.25,11.56,11.56,0,0,0,2.27.29,9,9,0,0,1,2.18.35,5.9,5.9,0,0,1,1.86,1,4.83,4.83,0,0,1,1.76,3.47c.09,1.29-.58,2.41-1,3.54a4.69,4.69,0,0,0-.27,1.72,2.4,2.4,0,0,0,.62,1.52,2.54,2.54,0,0,0,2.59.7,2.3,2.3,0,0,0,1.42-1.47,2.24,2.24,0,0,0,.09-1.3A1.2,1.2,0,0,0,196.76,215.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.14,217.83c.9,1.34-1.9,2.94-1.9,2.94.74.48.32,3-.86,3.22.54.33.91.33,1.2.9a2,2,0,0,1,.05,1.84,1.47,1.47,0,0,1-1.61.76,2.45,2.45,0,0,1,.48,2.73,2.4,2.4,0,0,1-1.27,1.18,2.59,2.59,0,0,1-.86.18,1.28,1.28,0,0,1-.34,0,.38.38,0,0,1-.13-.09c-.18-.15-.33-.34-.53-.48l-.22-.16a4.68,4.68,0,0,0-1.14-.51,4,4,0,0,1-.57-.15,3.15,3.15,0,0,1-.3-.24,5.85,5.85,0,0,0-2.32-.74,4.58,4.58,0,0,1-2.44-1,1.72,1.72,0,0,1-.19-2.39,1.16,1.16,0,0,1-1.05-1.13,1.66,1.66,0,0,1,.81-1.41,3.15,3.15,0,0,1,1.62-.44,1.28,1.28,0,0,1-.93-1.53,2,2,0,0,1,1.33-1.37,4.56,4.56,0,0,1,2-.13c.67.07,3.43.33,4.1.3l.49-1.83.06-.23c1.19-.28,1.53-.43,2.6-.61C261,217.3,261.77,217.27,262.14,217.83Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.37,234a2,2,0,0,1-.83,1.38,4,4,0,0,1-2.4-.06s.25-1.89.25-1.89l.07-.46c-.17-.4-1-.5-1.32-.73a1.46,1.46,0,0,1-.37-2,2,2,0,0,1,2-.78,3.06,3.06,0,0,1,1.84,1.21A4.26,4.26,0,0,1,257.37,234Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.24,227.53a49.38,49.38,0,0,0-10.05-1.72,25.81,25.81,0,0,0,5,1.12A25.54,25.54,0,0,0,259.24,227.53Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.53,224a14.35,14.35,0,0,0-4.5-1.11,14.11,14.11,0,0,0-4.63-.12,39.48,39.48,0,0,0,4.56.64A39.38,39.38,0,0,0,259.53,224Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,220.55a10.71,10.71,0,0,0-3.74-.77,14.54,14.54,0,0,0-3.82-.11,13.76,13.76,0,0,0,3.76.62A20.32,20.32,0,0,0,259.82,220.55Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.26,232.8c.06,0,.22-.32.1-.89a2.86,2.86,0,0,0-1.3-1.73,5.83,5.83,0,0,0-2-.8c-.63-.07-.91.33-.83.36s.31-.14.76,0a10.83,10.83,0,0,1,1.76.87A3.11,3.11,0,0,1,257,232C257.19,232.47,257.18,232.79,257.26,232.8Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,231.2c-5.78,5.27-9.68,7.26-10.43,12.69a34.22,34.22,0,0,0,1.51,14.23c3.13,9.27,7.13,20.17,9.56,25.41a8.65,8.65,0,0,1,.44,6.05c-1.36,4.55-5,13.22-4.44,30.83l54.1-3.78s-9.41-21.67-11.48-32.48c-.25-1.31,1.19-16.92.5-20-2.63-11.49-15.07-22.87-19.16-29l-.47-2-19.76-3.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.81,277.88s6.71,14,10.05,15.31S193,290.71,193,290.71l-1.69-6.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.09,239.64a5.17,5.17,0,0,1,.92.8c.56.55,1.34,1.38,2.24,2.46,1.83,2.14,4,5.36,6.5,8.81a37,37,0,0,1,5.21,9.64,23.21,23.21,0,0,1,.85,3.23,5,5,0,0,1,.13,1.21c-.09,0-.34-1.71-1.33-4.31a41,41,0,0,0-5.28-9.47c-2.51-3.46-4.63-6.69-6.37-8.88-.85-1.1-1.58-2-2.1-2.55A6.05,6.05,0,0,1,176.09,239.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,237.39s-11.7,7.84-4.66,21.53c6.26,12.17,16.42,27.11,20.52,29.46s48.34-7.2,48.34-7.2l-1.38-17.11-38,8-10.92-20.41S154.6,234.44,145,237.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,266.48s.44-1.83,3.7-4a13.62,13.62,0,0,0,4.7-5c.65-1,1.56-2.76,2.47-2.26s.75,1.89.13,4.08-2.47,4-1.75,4.84,10.74-.24,13.65-.83,4.28-.33,3.86,1.11-9.5,1.78-10.15,3.14S225,268.62,226,269s10.8-.68,11,1.1S236,272,236,272s.3,2.11-1.29,2.71-11.53-.6-11.2.65,8,1.88,8.24,3.84-1.67,1.21-3.67.79a52.84,52.84,0,0,0-9.42-1.47c-3.32-.05-9.68-.59-9.68-.59Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.13,272.21a42.31,42.31,0,0,1-6.63,0,43.51,43.51,0,0,1-6.61-.56,42.31,42.31,0,0,1,6.63,0A43.51,43.51,0,0,1,236.13,272.21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,277.88a5.1,5.1,0,0,1,.82-3.1,5,5,0,0,1,2.17-2.36c.1.11-.9,1.11-1.71,2.61S167.19,277.9,167,277.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6,247.7a4.84,4.84,0,0,1,.29.4c.18.27.43.69.75,1.23.65,1.09,1.57,2.72,2.74,4.82,2.32,4.2,5.65,10.27,9.61,17.84l-.22-.1,38-8.07.29-.06,0,.29c.45,5.49.91,11.18,1.38,17v.08l0,.23-.22.05c-11.3,2.42-22.09,4.54-32,6.1-2.47.39-4.89.73-7.24,1a56.67,56.67,0,0,1-6.91.45,10.65,10.65,0,0,1-1.68-.18,2.51,2.51,0,0,1-.81-.33L160,288a8.92,8.92,0,0,1-1.22-1.06,13,13,0,0,1-1.09-1.14c-.69-.77-1.36-1.54-1.95-2.34s-1.19-1.56-1.74-2.33c-4.37-6.19-7.39-11.53-9.5-15.19-1-1.84-1.83-3.28-2.35-4.27-.25-.47-.44-.85-.58-1.12a2.5,2.5,0,0,1-.18-.39,4,4,0,0,1,.22.36l.63,1.1,2.44,4.22c2.15,3.63,5.22,8.94,9.62,15.08.55.76,1.12,1.54,1.74,2.3s1.26,1.55,1.94,2.31a14.15,14.15,0,0,0,1.08,1.11,8.3,8.3,0,0,0,1.19,1l.63.47a.92.92,0,0,0,.33.16,1.37,1.37,0,0,0,.36.11,10.31,10.31,0,0,0,1.6.17,56,56,0,0,0,6.83-.48c2.35-.28,4.76-.63,7.23-1,9.86-1.58,20.65-3.72,31.93-6.14l-.2.28v-.09c-.47-5.84-.93-11.53-1.37-17l.31.23-38,7.95-.14,0-.07-.14c-3.9-7.57-7.19-13.68-9.45-17.91-1.14-2.09-2-3.73-2.64-4.86l-.71-1.26Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404ErrorwithpeopleholdingthenumbersPana);
export default __webpack_public_path__ + "static/media/404 error with people holding the numbers-pana.d4d21cc8c00991dcf41cfd45f16cc88e.svg";
export { ForwardRef as ReactComponent };